import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

type MinihompyTab = 'Home' | 'Profile' | 'Diary' | 'Photo' | 'Visitor' | 'Setting';
type MinihompyThemeId = 'sky' | 'gray' | 'blossom' | 'blush' | 'navy' | 'mono' | 'red-black' | 'pastel-pink' | 'pastel-blue' | 'pastel-green';
type Visibility = 'PUBLIC' | 'ILCHON' | 'PRIVATE';
type PhotoVisibilityFormValue = Visibility | 'INHERIT';
type GuestbookPolicy = 'AUTHENTICATED' | 'ILCHON' | 'OWNER';
type RelationshipStatus = 'NONE' | 'PENDING_SENT' | 'PENDING_RECEIVED' | 'ACCEPTED' | 'BLOCKED';
type MiniroomBackgroundFit = 'contain';
type ReportTargetType = 'MINIHOMPY' | 'USER' | 'DIARY' | 'PHOTO' | 'GUESTBOOK';
type ModerationStatus = 'PENDING_REVIEW' | 'HIDDEN_BY_MODERATOR' | 'DELETED';
type ShopItemType = 'THEME' | 'MINIROOM_BACKGROUND';

const MINIROOM_BACKGROUND_STORAGE_KEY = 'recollections-miniroom-background-id';
const MINIROOM_BACKGROUND_FIT_STORAGE_KEY = 'recollections-miniroom-background-fit';
const MINIROOM_BACKGROUND_FILES = [
    '1CD95E86-14C8-46B3-9B20-235F4281977C.gif',
    '2EC06CFA-128D-4BEE-BE7C-68044F2F4788.gif',
    '3C6A0E6F-36D6-4ECF-8B9B-A53CC126B223.gif',
    '451B8F9A-D695-4274-8820-EC6C3BFD7A91.gif',
    '4581E175-CBDE-405B-860A-7DD8DAD4C196.gif',
    '4C8C9CFA-D5DC-4702-9300-BD5E19A3D81B.gif',
    '542E216F-9138-4221-9435-10DD7A234F3E.gif',
    '58242971-4DBF-4199-9EAD-4EDF576F1865.gif',
    '5FC60083-3551-4C66-8949-95C4F3A65A63.gif',
    '601C6571-D7E3-4AC1-823D-9691F1C27705.gif',
    '650ED1A4-F466-44A5-81FF-784CBF09D6A7.gif',
    '6A140006-084B-44BF-9096-69940C35EE18.gif',
    '737AF248-0C73-4A7A-A5AC-24B02E1EB587.gif',
    '73FD4D0E-9EA1-43C9-974C-CFBD70BA4F73.gif',
    '78EDA79B-10A9-4FF9-B897-939288AE538E.gif',
    '82899506-5D34-4F8F-869E-982163368C40.gif',
    '83D0B041-282F-45A8-95B0-7509E465F1EB.gif',
    '8BD79C9C-954B-4382-947E-5C1C32AC9884.gif',
    '8E67B86B-5A8A-459F-905C-D767F7B57D0D.gif',
    '952B00E0-E653-47F0-AC14-E652DAF4974A.gif',
    '9AEDB624-DB25-4EC5-9C19-0161554B8251.gif',
    'BD3E675F-A44D-46F8-A203-A7B3AA39E5B1.gif',
    'C41B3803-5F09-42AA-82D8-DB2BD02DB521.gif',
    'C46763C7-DDD3-4453-8553-EBC13E698E8C.gif',
    'C9B46C02-CB26-471E-841B-1D2C1F7734DC.gif',
    'C9D3F47B-B3DA-43B4-ADDC-868C6A4F1951.gif',
    'D117B4B2-C1EE-4D23-BFB6-8741022F8A3C.gif',
    'D24967ED-D08F-4E76-BC84-91ED4E3710EA.gif',
    'D6F3494E-2D0E-43B9-87D0-B0B7A73DD1F2.gif',
    'DF00205A-5E82-422E-96EF-5DE1B0191A2E.gif',
    'E3A085E0-C618-4A2F-B07D-9BB0A2BAD87C.gif',
    'E8F76F9A-0905-47AD-B933-48A53B1F715A.gif',
    'EB01BF68-033A-477D-84A9-5324EF4F9909.gif',
    'F8DCC4F9-472F-4E3C-8C7D-FDD84B6CBB70.gif',
    'F9241827-F584-44A0-A810-B5F9A5933172.gif',
    'IMG_3938.jpeg',
    'IMG_3939.gif',
    'IMG_3940.gif',
    'IMG_3941.jpeg',
    'IMG_3942.jpeg',
    'IMG_3947.jpeg'
];

interface TabMeta {
    id: MinihompyTab;
    slug: string;
    label: string;
    title: string;
    description: string;
}

interface ThemeMeta {
    id: MinihompyThemeId;
    label: string;
    tone: string;
}

interface HomeReviewItem {
    title: string;
    body: string;
    date: string;
    sortKey: string;
}

interface MiniroomBackground {
    id: string;
    ownerId: string;
    minihompyId?: string;
    fileId?: string;
    assetPath: string;
    title: string;
    description?: string;
    originalFilename?: string;
    storedFilename?: string;
    mimeType: string;
    fileSize?: number;
    isAnimated: boolean;
    width: number;
    height: number;
    sourceType?: string;
    status?: string;
    createdAt: string;
    updatedAt?: string;
}

interface ShopItem {
    id: string;
    itemId: string;
    type: ShopItemType;
    title: string;
    preview: string;
    price: number;
    owned: boolean;
    current: boolean;
    available: boolean;
    admin?: boolean;
    status?: string;
    purchaseReady?: boolean;
    actionLabel?: string;
    sortOrder?: number;
}

interface MinihompyProfile {
    id: string;
    ownerId: string;
    slug: string;
    visibility: Visibility;
    status: string;
    nickname: string;
    title: string;
    statusMessage: string;
    profileImageUrl: string;
    bio: string;
    themeId: MinihompyThemeId;
    defaultDiaryVisibility: Visibility;
    defaultPhotoVisibility: Visibility;
    selectedMiniroomBackgroundId: string;
    selectedMiniroomBackgroundAssetPath?: string;
    selectedMiniroomBackground?: MiniroomBackground | null;
    miniroomBackgroundFit: MiniroomBackgroundFit;
    guestbookWritePolicy: GuestbookPolicy;
    bgmEnabled: boolean;
    bgmTrackTitle: string;
    todayVisitCount: number;
    totalVisitCount: number;
    updatedAt: string;
}

interface ProfileViewModel {
    name: string;
    title: string;
    status: string;
    history: string;
    mood: string;
    bio: string;
    profileImageUrl: string;
}

interface DiaryEntry {
    id: string;
    ownerId: string;
    date: string;
    entryDate: string;
    month?: string;
    title: string;
    body: string;
    visibility: Visibility;
    mood: string;
    status: string;
    createdAt: string;
    updatedAt: string;
}

interface DiaryForm {
    id: string;
    title: string;
    body: string;
    entryDate: string;
    mood: string;
    visibility: Visibility;
}

interface DiaryMonth {
    key: string;
    label: string;
    count: number;
}

interface PhotoAlbum {
    id: string;
    ownerId: string;
    name: string;
    count: number;
    note: string;
    visibility: Visibility;
    status: string;
    coverPhoto?: PhotoItem | null;
    createdAt?: string;
    updatedAt?: string;
}

interface PhotoFileAccess {
    mode: 'PUBLIC_URL' | 'SIGNED_URL' | 'PLACEHOLDER';
    isPublic: boolean;
    url?: string;
    signedUrl?: string;
    signedUrlRequest?: {
        method: string;
        endpoint: string;
        photoId: string;
        fileId: string;
        assetKind: string;
        visibility: Visibility;
        expiresIn: number;
        cacheControl: string;
    };
    expiresIn?: number;
    cacheControl?: string;
    note?: string;
}

interface PhotoItem {
    id: string;
    ownerId: string;
    albumId: string;
    albumName: string;
    title: string;
    caption: string;
    date: string;
    takenAt: string;
    visibility: PhotoVisibilityFormValue;
    effectiveVisibility: Visibility;
    status: string;
    imageUrl: string;
    fileAccess: PhotoFileAccess;
    fileName?: string;
    mimeType?: string;
    fileSize?: number;
    createdAt: string;
    updatedAt: string;
}

interface PhotoAlbumForm {
    id: string;
    name: string;
    note: string;
    visibility: Visibility;
}

interface PhotoForm {
    id: string;
    albumId: string;
    title: string;
    caption: string;
    takenAt: string;
    sourceUrl: string;
    fileName: string;
    mimeType: string;
    fileSize: number;
    visibility: PhotoVisibilityFormValue;
}

interface GuestbookEntry {
    id?: string;
    authorId?: string;
    name: string;
    date: string;
    createdAt?: string;
    message: string;
    status?: string;
    isHidden?: boolean;
    canHide?: boolean;
    canDelete?: boolean;
    canManage?: boolean;
}

interface GuestbookForm {
    message: string;
}

interface RelationshipContext {
    status: RelationshipStatus;
    targetUserId: string;
    targetName: string;
    viewerUserId: string;
    viewerName: string;
    canRequest: boolean;
    canAccept: boolean;
    canDelete: boolean;
    canBlock: boolean;
}

interface IlchonItem {
    id?: string;
    userId: string;
    name: string;
    status: RelationshipStatus;
    requestedAt?: string;
    updatedAt?: string;
    blockedAt?: string;
    canAccept?: boolean;
    canDelete?: boolean;
    canBlock?: boolean;
}

interface IlchonOverview {
    accepted: IlchonItem[];
    incoming: IlchonItem[];
    outgoing: IlchonItem[];
    blocked: IlchonItem[];
}

interface ModerationReport {
    id: string;
    status: ModerationStatus;
    targetType: ReportTargetType;
    targetId: string;
    targetLabel: string;
    targetStatus: string;
    targetOwnerId: string;
    reporterId: string;
    reporterName: string;
    reason: string;
    createdAt: string;
    updatedAt: string;
    moderatorId?: string;
    moderatedAt?: string;
}

interface ModerationPayload {
    canModerate: boolean;
    statusOptions: ModerationStatus[];
    reports: ModerationReport[];
}

interface AccessMatrix {
    role: 'ADMIN' | 'USER';
    isAdmin: boolean;
    isOwner: boolean;
    relationshipStatus: RelationshipStatus;
    canViewMinihompy: boolean;
    canEditProfile: boolean;
    canCreateDiary: boolean;
    canCreatePhoto: boolean;
    canManageCatalog: boolean;
    canUseThemeSwitcher: boolean;
    canUseAllThemes: boolean;
    canUseAllMiniroomBackgrounds: boolean;
    canWriteGuestbook: boolean;
    canRequestIlchon: boolean;
    canAcceptIlchon: boolean;
    canDeleteIlchon: boolean;
    canBlockUser: boolean;
    canReport: boolean;
    canModerateReports: boolean;
}

interface SettingsForm {
    nickname: string;
    title: string;
    statusMessage: string;
    profileImageUrl: string;
    bio: string;
    themeId: MinihompyThemeId;
    defaultDiaryVisibility: Visibility;
    defaultPhotoVisibility: Visibility;
    selectedMiniroomBackgroundId: string;
    miniroomBackgroundFit: MiniroomBackgroundFit;
    guestbookWritePolicy: GuestbookPolicy;
    bgmEnabled: boolean;
    bgmTrackTitle: string;
}

interface MiniroomBackgroundForm {
    id: string;
    title: string;
    assetPath: string;
    description: string;
    originalFilename: string;
    mimeType: string;
    width: number;
    height: number;
}

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  min-width: 0;
  min-height: 100dvh;
  background: #aeb8bd;
}

.ThemeProvider {
  --minihompy-scale: 0.75;
  --canvas-width: 1920px;
  --canvas-height: 1080px;
  --content-panel-width: 864px;
  --shell-padding-left: 52px;
  --shell-padding-right: 48px;
  --shell-border-size: 2px;
  --window-pad-x: 18px;
  --window-pad-y: 17px;
  --window-border-size: 1px;
  --panel-gap: 14px;
  --panel-gap-half: 7px;
  --shell-horizontal-chrome: calc(var(--shell-padding-left) + var(--shell-padding-right) + (var(--shell-border-size) * 2) + (var(--window-pad-x) * 2) + (var(--window-border-size) * 2) + var(--panel-gap));
  --shell-width: calc(var(--profile-panel-width) + var(--content-panel-width) + var(--shell-horizontal-chrome));
  --shell-height: clamp(760px, 79.63vh, 860px);
  --workspace-gap: 74px;
  --workspace-width: calc(var(--shell-width) + var(--workspace-gap) + var(--right-widget-width));
  --workspace-height: var(--shell-height);
  --profile-panel-width: 286px;
  --profile-panel-padding-x: 22px;
  --profile-panel-padding-top: 42px;
  --profile-panel-padding-bottom: 20px;
  --profile-panel-gap: 12px;
  --profile-photo-height: 304px;
  --tab-width: 96px;
  --tab-height: 56px;
  --right-widget-width: clamp(300px, 17.2vw, 330px);
  --page-bg: #aeb8bd;
  --grid-line: rgba(62, 81, 92, 0.14);
  --shell-bg: #c7e5ec;
  --shell-border: #728991;
  --inner-border: #ffffff;
  --stitch-color: rgba(255, 255, 255, 0.96);
  --window-bg: #eef1f1;
  --window-border: #c5d0d4;
  --window-shadow: rgba(72, 105, 118, 0.18);
  --panel-bg: #ffffff;
  --panel-alt-bg: #f7fbfd;
  --panel-border: #bdcbd1;
  --accent: #36a8c7;
  --accent-strong: #187f9c;
  --accent-soft: #d9f2f7;
  --tab-bg: var(--accent);
  --tab-active-bg: #ffffff;
  --tab-text: #ffffff;
  --tab-active-text: #4f5d62;
  --tab-border: var(--accent-strong);
  --tab-active-border: var(--panel-border);
  --heading-color: #44545a;
  --text: #39484f;
  --muted-text: #7a8b91;
  --danger: #cc3434;
  --shadow: rgba(40, 55, 62, 0.22);
  --font-retro: "DungGeunMo", "Galmuri11", "NeoDunggeunmo", "Courier New", "GulimChe", "Gulim", monospace;
  --font-body: SUIT, "Apple SD Gothic Neo", "Malgun Gothic", sans-serif;
  --content-letter-spacing: 0.028em;
  --content-retro-letter-spacing: 0.042em;
  --content-button-letter-spacing: 0.034em;
  --content-body-font-size: 16px;
  --content-small-font-size: 15px;
  --content-micro-font-size: 14px;
  --content-card-title-font-size: 17px;
  --content-detail-body-font-size: 17px;
  --content-detail-title-font-size: 18px;
  --content-profile-name-font-size: 21px;
  --content-widget-count-font-size: 19px;
  position: relative;
  isolation: isolate;
  width: 100%;
  min-width: 0;
  min-height: 100dvh;
  color: var(--text);
  font-family: var(--font-body);
  -webkit-font-smoothing: none;
  text-rendering: geometricPrecision;
  background-color: var(--page-bg);
  background-image: linear-gradient(var(--grid-line) 1px, transparent 1px), linear-gradient(90deg, var(--grid-line) 1px, transparent 1px);
  background-size: 24px 24px;
}

.ThemeProvider::before {
  content: "";
  position: fixed;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  background-color: var(--page-bg);
  background-image: linear-gradient(var(--grid-line) 1px, transparent 1px), linear-gradient(90deg, var(--grid-line) 1px, transparent 1px);
  background-size: 24px 24px;
}

.ThemeProvider[data-theme=gray] {
  --page-bg: #b4b4b4;
  --grid-line: rgba(30, 30, 30, 0.12);
  --shell-bg: #e5e5e5;
  --shell-border: #777777;
  --window-bg: #ededed;
  --window-border: #cacaca;
  --panel-border: #c2c2c2;
  --accent: #777f86;
  --accent-strong: #555d64;
  --accent-soft: #eceff1;
  --heading-color: #4c4c4c;
}

.ThemeProvider[data-theme=blossom] {
  --page-bg: #cfcfcf;
  --grid-line: rgba(75, 75, 75, 0.12);
  --shell-bg: #eeeeee;
  --shell-border: #868686;
  --inner-border: #ffffff;
  --window-bg: #e8e8e8;
  --window-border: #d1d1d1;
  --panel-bg: #ffffff;
  --panel-alt-bg: #f8f8f8;
  --panel-border: #d1d1d1;
  --accent: #858585;
  --accent-strong: #707070;
  --accent-soft: #eeeeee;
  --tab-bg: #f8e1ea;
  --tab-active-bg: #f8e1ea;
  --tab-text: #6a5960;
  --tab-active-text: #514349;
  --tab-border: #e6c6d2;
  --tab-active-border: #ddb7c6;
  --heading-color: #666666;
  --muted-text: #858585;
  --shadow: rgba(55, 55, 55, 0.22);
}

.ThemeProvider[data-theme=blossom] .profile-photo__house {
  box-shadow: 36px -28px 0 -14px #d5d5d5, 36px -28px 0 -12px #9a9a9a;
}

.ThemeProvider[data-theme=blossom] .room-frame {
  border-color: #d7d7d7;
  box-shadow: inset 0 0 0 1px #b9b9b9;
}

.ThemeProvider[data-theme=blush] {
  --page-bg: #f4dde5;
  --grid-line: rgba(150, 90, 110, 0.08);
  --shell-bg: #fbf0f4;
  --shell-border: #e0b4c2;
  --window-bg: #f4e8ed;
  --window-border: #e8c9d5;
  --panel-border: #ecd4dd;
  --accent: #efb5ca;
  --accent-strong: #c9849b;
  --accent-soft: #fff3f7;
  --heading-color: #8a5f6f;
}

.ThemeProvider[data-theme=navy] {
  --page-bg: #7f8fa5;
  --grid-line: rgba(245, 248, 255, 0.16);
  --shell-bg: #dce4ec;
  --shell-border: #33445c;
  --stitch-color: rgba(255, 255, 255, 0.82);
  --window-bg: #d1dbe5;
  --window-border: #9faebe;
  --panel-border: #b4c1cf;
  --accent: #2e4f78;
  --accent-strong: #1d334f;
  --accent-soft: #dfe9f5;
  --heading-color: #26394f;
  --shadow: rgba(14, 27, 42, 0.3);
}

.ThemeProvider[data-theme=red-black] {
  --page-bg: #252525;
  --grid-line: rgba(255, 255, 255, 0.08);
  --shell-bg: #343434;
  --shell-border: #111111;
  --inner-border: #555555;
  --stitch-color: rgba(255, 255, 255, 0.68);
  --window-bg: #454545;
  --window-border: #606060;
  --panel-bg: #f8f8f8;
  --panel-alt-bg: #fff5f5;
  --panel-border: #b6b6b6;
  --accent: #c82828;
  --accent-strong: #8e1111;
  --accent-soft: #ffe1e1;
  --heading-color: #262626;
  --tab-text: #ffffff;
  --shadow: rgba(0, 0, 0, 0.38);
}

.ThemeProvider[data-theme=mono] {
  --page-bg: #d2d2d2;
  --grid-line: rgba(0, 0, 0, 0.1);
  --shell-bg: #f0f0f0;
  --shell-border: #363636;
  --window-bg: #e7e7e7;
  --window-border: #bdbdbd;
  --panel-border: #b8b8b8;
  --accent: #f8f8f8;
  --accent-strong: #666666;
  --accent-soft: #eeeeee;
  --heading-color: #242424;
  --tab-bg: #f8f8f8;
  --tab-text: #888888;
  --tab-active-text: #444444;
  --danger: #222222;
}

.ThemeProvider[data-theme=pastel-pink] {
  --page-bg: #f8e6ed;
  --grid-line: rgba(180, 120, 145, 0.08);
  --shell-bg: #fff4f8;
  --shell-border: #e8c2d0;
  --window-bg: #f8eaf0;
  --window-border: #edd1dc;
  --panel-border: #efd9e3;
  --accent: #f2c5d6;
  --accent-strong: #cf8da4;
  --accent-soft: #fff6fa;
  --heading-color: #8a6070;
}

.ThemeProvider[data-theme=pastel-blue] {
  --page-bg: #dfeef5;
  --grid-line: rgba(95, 130, 150, 0.08);
  --shell-bg: #f3fbff;
  --shell-border: #b9d7e6;
  --window-bg: #e8f3f8;
  --window-border: #cfe3ed;
  --panel-border: #d5e7f0;
  --accent: #a9d7e8;
  --accent-strong: #6fa8bd;
  --accent-soft: #eefaff;
  --heading-color: #557886;
}

.ThemeProvider[data-theme=pastel-green] {
  --page-bg: #e4f0df;
  --grid-line: rgba(100, 130, 90, 0.08);
  --shell-bg: #f6fcf2;
  --shell-border: #bdd9b2;
  --window-bg: #edf6e9;
  --window-border: #d1e5ca;
  --panel-border: #d7ead0;
  --accent: #acdca2;
  --accent-strong: #79a96d;
  --accent-soft: #f1fbec;
  --heading-color: #627d5a;
}

.minihompy-stage * {
  box-sizing: border-box;
}

button,
select,
input {
  font-family: inherit;
}

.theme-quick-switch {
  position: fixed;
  top: 8px;
  right: 28px;
  z-index: 20;
  display: flex;
  flex-wrap: nowrap;
  gap: 5px;
  max-width: none;
  padding: 4px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.62);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.12);
}

.theme-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 22px;
  padding: 0 6px;
  border: 1px solid var(--panel-border);
  border-radius: 5px;
  color: var(--muted-text);
  background: var(--panel-bg);
  font-family: var(--font-retro);
  font-size: 10px;
  line-height: 1;
}

.theme-chip.is-active {
  border-color: var(--accent-strong);
  color: var(--accent-strong);
  font-weight: 800;
}

.theme-chip__swatch {
  width: 9px;
  height: 9px;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  background: var(--accent);
}

.scroll-affordance {
  display: none;
}

.minihompy-viewport {
  width: 100%;
  min-width: 0;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 62px 28px 38px;
  overflow-x: auto;
  overflow-y: visible;
}

.minihompy-workspace {
  display: flex;
  flex: 0 0 calc(var(--workspace-width) * var(--minihompy-scale));
  align-items: flex-start;
  justify-content: flex-start;
  width: calc(var(--workspace-width) * var(--minihompy-scale));
  height: calc(var(--workspace-height) * var(--minihompy-scale));
  gap: var(--workspace-gap);
  overflow: visible;
  transform: scale(var(--minihompy-scale));
  transform-origin: top left;
}

.MinihompyShell {
  position: relative;
  flex: 0 0 var(--shell-width);
  width: var(--shell-width);
  height: var(--shell-height);
  padding: 16px var(--shell-padding-right) 48px var(--shell-padding-left);
  border: var(--shell-border-size) solid var(--shell-border);
  border-radius: 28px;
  background: var(--shell-bg);
  box-shadow: none;
}

.shell-stitch {
  position: absolute;
  top: 38px;
  right: 38px;
  bottom: 38px;
  left: 42px;
  z-index: 1;
  border: 1px dashed var(--stitch-color);
  border-radius: 22px;
  box-shadow: none;
  pointer-events: none;
}

.shell-header {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 30px;
  padding: 0 92px 5px 4px;
  color: var(--heading-color);
}

.shell-title p,
.shell-title h1 {
  margin: 0;
}

.shell-title p {
  font-family: var(--font-retro);
  font-size: 10px;
  letter-spacing: 0;
  color: var(--accent-strong);
}

.shell-title h1 {
  margin-top: 2px;
  font-family: var(--font-retro);
  font-size: 16px;
  line-height: 1.1;
}

.shell-counter,
.visit-card {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-retro);
  font-size: 12px;
  color: var(--muted-text);
}

.shell-counter strong,
.visit-card strong {
  color: var(--danger);
  font-weight: 800;
}

.shell-body {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: var(--profile-panel-width) var(--content-panel-width);
  gap: var(--panel-gap);
  height: calc(100% - 30px);
  padding: var(--window-pad-y) var(--window-pad-x) 18px;
  border: var(--window-border-size) solid var(--window-border);
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.52), rgba(255, 255, 255, 0) 54px), var(--window-bg);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.78), inset 0 0 0 5px rgba(255, 255, 255, 0.22), 0 1px 0 rgba(255, 255, 255, 0.74), 0 10px 20px var(--window-shadow);
}

.shell-body::before {
  content: "";
  position: absolute;
  top: var(--window-pad-y);
  bottom: 18px;
  left: calc(var(--window-pad-x) + var(--profile-panel-width) + var(--panel-gap-half));
  z-index: 0;
  border-left: 1px dashed var(--stitch-color);
  opacity: 0.92;
}

.ProfilePanel,
.ContentPanel {
  position: relative;
  z-index: 1;
  min-height: 0;
  border: 1px solid var(--panel-border);
  border-radius: 12px;
  background: var(--panel-bg);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.86), 0 0 0 4px rgba(255, 255, 255, 0.5), inset 0 0 0 3px #f5f5f5;
}

.ProfilePanel {
  grid-column: 1;
  display: flex;
  flex-direction: column;
  gap: var(--profile-panel-gap);
  min-width: 0;
  padding: var(--profile-panel-padding-top) var(--profile-panel-padding-x) var(--profile-panel-padding-bottom);
}

.visit-card {
  flex-wrap: wrap;
  justify-content: center;
  min-height: 28px;
  padding: 3px 7px;
  border: 1px solid var(--panel-border);
  border-radius: 6px;
  background: linear-gradient(#ffffff, var(--panel-alt-bg));
  line-height: 1.25;
}

.visit-card i {
  color: #b1b1b1;
  font-style: normal;
}

.profile-photo {
  position: relative;
  height: var(--profile-photo-height);
  overflow: hidden;
  border: 1px solid var(--panel-border);
  border-radius: 7px;
  background: linear-gradient(#bfe8f4 0 54%, #eef8f8 54% 100%);
}

.profile-photo img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-photo__sky {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.36) 1px, transparent 1px), linear-gradient(rgba(255, 255, 255, 0.28) 1px, transparent 1px);
  background-size: 18px 18px;
}

.profile-photo__sun {
  position: absolute;
  top: 20px;
  right: 24px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #ffe68d;
  border: 2px solid rgba(200, 160, 55, 0.35);
}

.profile-photo__house {
  position: absolute;
  left: 34px;
  bottom: 34px;
  width: 98px;
  height: 60px;
  border: 2px solid #8aa1aa;
  border-radius: 5px;
  background: #ffffff;
  box-shadow: 36px -28px 0 -14px #f4a7b7, 36px -28px 0 -12px #8aa1aa;
}

.profile-photo__house::before,
.profile-photo__house::after {
  content: "";
  position: absolute;
  bottom: 12px;
  width: 20px;
  height: 27px;
  border: 2px solid #91a8b0;
  background: var(--accent-soft);
}

.profile-photo__house::before {
  left: 15px;
}

.profile-photo__house::after {
  right: 15px;
}

.profile-photo__ground {
  position: absolute;
  left: -20px;
  right: -20px;
  bottom: -18px;
  height: 74px;
  border-top: 2px solid rgba(87, 128, 85, 0.25);
  background: repeating-linear-gradient(90deg, #c8e5b9 0 28px, #bde0af 28px 56px);
  transform: rotate(-1deg);
}

.profile-nameplate,
.profile-box,
.profile-select {
  min-width: 0;
  border: 1px solid var(--panel-border);
  border-radius: 7px;
  background: var(--panel-alt-bg);
}

.profile-nameplate {
  padding: 11px 11px 12px;
}

.profile-label,
.profile-box h3,
.section-head span,
.content-titlebar span {
  font-family: var(--font-retro);
  font-size: 11px;
  color: var(--accent-strong);
}

.profile-nameplate h2 {
  margin: 4px 0 6px;
  font-size: 17px;
  line-height: 1.1;
  color: var(--heading-color);
  overflow-wrap: anywhere;
}

.profile-nameplate p,
.profile-box p {
  margin: 0;
  font-size: 12px;
  line-height: 1.55;
  color: var(--text);
  overflow-wrap: anywhere;
}

.profile-box {
  padding: 9px 10px;
}

.profile-box h3,
.mini-section h3 {
  margin: 0 0 8px;
  font-size: 13px;
  line-height: 1.2;
  color: var(--heading-color);
}

.profile-box--note {
  background: #fffdf4;
}

.profile-select {
  margin-top: auto;
  padding: 9px;
}

.profile-select label {
  display: block;
  margin-bottom: 5px;
  font-size: 11px;
  color: var(--muted-text);
}

.profile-select select {
  width: 100%;
  height: 30px;
  padding: 0 8px;
  border: 1px solid var(--panel-border);
  border-radius: 4px;
  background: #fff;
  color: var(--text);
  font-size: 12px;
  line-height: 30px;
}

.HingeDecorations {
  position: absolute;
  top: var(--window-pad-y);
  bottom: 18px;
  left: calc(var(--window-pad-x) + var(--profile-panel-width) + var(--panel-gap-half) - 17px);
  z-index: 2;
  width: 34px;
  pointer-events: none;
}

.HingeDecorations span {
  position: absolute;
  left: 50%;
  width: 32px;
  height: 13px;
  transform: translateX(-50%);
  border: 1px solid #9aa8ad;
  border-radius: 999px;
  background: linear-gradient(90deg, #fafafa 0 42%, #b8c4c8 42% 58%, #fafafa 58% 100%);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.14);
}

.HingeDecorations span:nth-child(1) {
  top: 22%;
}

.HingeDecorations span:nth-child(2) {
  top: 29%;
}

.HingeDecorations span:nth-child(3) {
  bottom: 20%;
}

.HingeDecorations span:nth-child(4) {
  bottom: 13%;
}

.ContentPanel {
  grid-column: 2;
  position: relative;
  overflow: auto;
  padding: 18px 42px 20px 20px;
}

.ContentPanel::after {
  content: "";
  position: absolute;
  top: 20px;
  right: 17px;
  bottom: 20px;
  width: 18px;
  border-radius: 0;
  background: linear-gradient(#aeb4b7 0 34px, transparent 34px calc(100% - 34px), #aeb4b7 calc(100% - 34px)), linear-gradient(#eeeeee, #f8f8f8);
  border: 1px solid var(--panel-border);
  box-shadow: inset 0 35px 0 rgba(255, 255, 255, 0.36), inset 0 -35px 0 rgba(255, 255, 255, 0.36);
  pointer-events: none;
}

.RetroScrollbar {
  scrollbar-color: var(--accent) var(--accent-soft);
  scrollbar-width: thin;
}

.RetroScrollbar::-webkit-scrollbar {
  width: 13px;
}

.RetroScrollbar::-webkit-scrollbar-track {
  background: var(--accent-soft);
  border-left: 1px solid var(--panel-border);
}

.RetroScrollbar::-webkit-scrollbar-thumb {
  border: 3px solid var(--accent-soft);
  border-radius: 999px;
  background: var(--accent);
}

.content-titlebar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 16px;
  padding: 0 3px 12px;
  border-bottom: 1px solid var(--panel-border);
}

.content-titlebar h2,
.content-titlebar p {
  margin: 0;
}

.content-titlebar h2 {
  margin-top: 2px;
  font-family: var(--font-retro);
  font-size: 22px;
  color: var(--heading-color);
}

.content-titlebar p {
  max-width: 320px;
  font-size: 12px;
  line-height: 1.45;
  color: var(--muted-text);
  text-align: right;
}

.tab-screen {
  display: grid;
  gap: 14px;
}

.mini-section {
  border: 1px solid var(--panel-border);
  border-radius: 5px;
  background: #fff;
  padding: 14px;
}

.Review,
.Miniroom {
  border-color: #c8d1d5;
  border-radius: 4px;
}

.Review {
  --review-date-width: 137px;
  --review-date-text-offset-x: 2px;
}

.Miniroom {
  --miniroom-frame-height: 380px;
  --miniroom-image-overscan: 1.015;
  --miniroom-image-overscan-y: -2px;
}

.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  border-bottom: 1px dotted var(--panel-border);
}

.section-head h3 {
  font-family: var(--font-retro);
  font-size: 15px;
  color: var(--accent-strong);
}

.section-head span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.review-list,
.diary-list,
.visitor-list {
  display: grid;
  gap: 8px;
}

.Review .review-list {
  gap: 0;
  padding: 8px 10px;
  background: #f7f7f7;
}

.review-item,
.diary-entry,
.visitor-note {
  display: grid;
  gap: 10px;
  border: 1px solid #e1e6e8;
  border-radius: 6px;
  background: #ffffff;
}

.review-item {
  grid-template-columns: var(--review-date-width) 1px minmax(0, 1fr);
  gap: 0;
  padding: 0;
  border: 0;
  border-bottom: 1px solid #e4e8ea;
  border-radius: 0;
  background: transparent;
}

.review-item::before {
  content: "";
  grid-column: 2;
  grid-row: 1;
  align-self: stretch;
  border-left: 1px dotted var(--panel-border);
}

.review-item:last-child {
  border-bottom: 0;
}

.review-item > div:not(.review-date) {
  grid-column: 3;
  grid-row: 1;
  min-width: 0;
  padding: 12px 8px 12px 12px;
}

.review-date {
  grid-column: 1;
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-width: 0;
  padding: 12px calc(var(--review-date-text-offset-x) * 2) 12px 0;
  border-right: 0;
  color: var(--accent-strong);
  font-family: var(--font-retro);
  font-size: 11px;
  white-space: nowrap;
}

.review-item h4,
.diary-entry h4,
.album-card h4 {
  margin: 0 0 4px;
  font-size: 13px;
  color: var(--heading-color);
}

.review-item p,
.diary-entry p,
.album-card p,
.visitor-note p,
.paragraph,
.bgm-card p,
.friend-card p {
  margin: 0;
  font-size: 12px;
  line-height: 1.55;
  color: var(--muted-text);
}

.miniroom-frame {
  position: relative;
  height: var(--miniroom-frame-height);
  min-height: var(--miniroom-frame-height);
  max-height: var(--miniroom-frame-height);
  overflow: hidden;
  border: 1px solid #b7c8ce;
  border-radius: 2px;
  background: #eaf6fb;
}

.miniroom-frame.has-background {
  display: block;
  padding: 0;
  border: 0;
  background: #fff;
  box-shadow: none;
  line-height: 0;
}

.miniroom-background-image {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  object-fit: cover;
  object-position: center top;
}

.miniroom-frame.has-background .miniroom-background-image {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  object-fit: cover;
  object-position: center top;
  transform: translateY(var(--miniroom-image-overscan-y)) scale(var(--miniroom-image-overscan));
  transform-origin: center top;
  vertical-align: top;
  background: transparent;
}

.miniroom-frame.fit-cover .miniroom-background-image {
  object-fit: cover;
}

.miniroom-frame.fit-stretch .miniroom-background-image {
  object-fit: fill;
}

.room-wall {
  position: absolute;
  inset: 0 0 42%;
  background-image: linear-gradient(90deg, rgba(70, 120, 145, 0.14) 1px, transparent 1px), linear-gradient(rgba(70, 120, 145, 0.14) 1px, transparent 1px);
  background-size: 26px 26px;
}

.room-floor {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 45%;
  background: repeating-linear-gradient(90deg, #ecd6b8 0 34px, #e2c7a4 34px 68px);
  transform: skewY(-3deg);
  transform-origin: left top;
}

.room-window,
.room-frame,
.room-rug,
.room-desk,
.room-chair,
.room-shelf,
.room-person {
  position: absolute;
  display: block;
}

.room-window {
  top: 28px;
  right: 58px;
  width: 116px;
  height: 68px;
  border: 5px solid #ffffff;
  background: linear-gradient(#99cfe6 0 50%, #d9f4ff 50% 100%);
  box-shadow: 0 0 0 1px #a8bbc5;
}

.room-frame {
  top: 28px;
  left: 48px;
  width: 96px;
  height: 62px;
  border: 8px solid #e7b0bd;
  background: #fff7df;
  box-shadow: inset 0 0 0 1px #bf8594;
}

.room-rug {
  left: 31%;
  bottom: 30px;
  width: 230px;
  height: 66px;
  border-radius: 50%;
  background: var(--accent-soft);
  border: 2px solid rgba(80, 120, 130, 0.18);
}

.room-desk {
  left: 78px;
  bottom: 58px;
  width: 170px;
  height: 50px;
  border: 2px solid #94724e;
  background: #c79258;
  box-shadow: 20px 45px 0 -16px #856446, 118px 45px 0 -16px #856446;
}

.room-chair {
  left: 266px;
  bottom: 55px;
  width: 58px;
  height: 74px;
  border: 2px solid #6e8ba0;
  border-radius: 8px 8px 3px 3px;
  background: #c9e0ec;
}

.room-shelf {
  right: 72px;
  bottom: 78px;
  width: 136px;
  height: 86px;
  border: 2px solid #9b7654;
  background: repeating-linear-gradient(180deg, #d2a06f 0 20px, #a9784e 20px 24px);
}

.room-person {
  left: 50%;
  bottom: 76px;
  width: 42px;
  height: 78px;
  transform: translateX(-50%);
}

.room-person span:first-child {
  position: absolute;
  top: 0;
  left: 9px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #f0c0a8;
  border: 2px solid #5f5f5f;
}

.room-person span:last-child {
  position: absolute;
  bottom: 0;
  left: 4px;
  width: 34px;
  height: 52px;
  border-radius: 10px 10px 5px 5px;
  background: var(--accent);
  border: 2px solid #5f5f5f;
}

.room-caption {
  position: absolute;
  left: 14px;
  bottom: 12px;
  margin: 0;
  padding: 5px 8px;
  border: 1px solid var(--panel-border);
  border-radius: 4px;
  color: var(--muted-text);
  background: rgba(255, 255, 255, 0.82);
  font-family: var(--font-retro);
  font-size: 11px;
}

.home-summary {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.summary-row {
  min-width: 0;
  padding: 9px 10px;
  border: 1px solid #e2e7e9;
  border-radius: 5px;
  background: var(--panel-alt-bg);
}

.summary-row span,
.summary-row strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary-row span {
  margin-bottom: 3px;
  color: var(--accent-strong);
  font-family: var(--font-retro);
  font-size: 11px;
}

.summary-row strong {
  color: var(--text);
  font-size: 12px;
}

.profile-detail-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);
  gap: 14px;
}

.info-list,
.setting-list {
  display: grid;
  gap: 9px;
  margin: 0;
}

.info-list div,
.setting-list div {
  display: grid;
  grid-template-columns: 128px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px dotted var(--panel-border);
}

.info-list dt,
.setting-list dt {
  color: var(--accent-strong);
  font-family: var(--font-retro);
  font-size: 11px;
}

.info-list dd,
.setting-list dd {
  min-width: 0;
  margin: 0;
  color: var(--text);
  font-size: 12px;
}

.tag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 13px;
}

.tag-row span {
  padding: 4px 8px;
  border: 1px solid var(--panel-border);
  border-radius: 999px;
  color: var(--accent-strong);
  background: var(--accent-soft);
  font-family: var(--font-retro);
  font-size: 11px;
}

.relationship-panel {
  background: #fffdf7;
}

.relationship-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 12px;
}

.ilchon-manager {
  background: var(--panel-alt-bg);
}

.ilchon-lanes {
  display: grid;
  gap: 10px;
}

.ilchon-lane {
  display: grid;
  gap: 7px;
}

.ilchon-lane h4 {
  margin: 0;
  color: var(--accent-strong);
  font-family: var(--font-retro);
  font-size: 12px;
  font-weight: 400;
}

.ilchon-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  min-height: 42px;
  padding: 8px 10px;
  border: 1px solid var(--panel-border);
  border-radius: 5px;
  background: #fff;
}

.ilchon-row strong,
.ilchon-row span {
  display: block;
}

.ilchon-row strong {
  color: var(--text);
  font-size: 12px;
}

.ilchon-row span {
  color: var(--muted-text);
  font-family: var(--font-retro);
  font-size: 11px;
}

.ilchon-row__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 5px;
}

.ilchon-row__actions button {
  height: 26px;
  min-width: 42px;
  border: 1px solid var(--panel-border);
  border-radius: 4px;
  color: var(--muted-text);
  background: #f6f6f6;
  font-family: var(--font-retro);
  font-size: 11px;
}

.diary-entry {
  grid-template-columns: 62px minmax(0, 1fr) 54px;
  align-items: center;
  padding: 10px;
}

.diary-entry time {
  color: var(--accent-strong);
  font-family: var(--font-retro);
  font-size: 12px;
}

.diary-entry button,
.friend-card button,
.widget-strip button {
  height: 28px;
  border: 1px solid var(--panel-border);
  border-radius: 4px;
  color: var(--muted-text);
  background: #f6f6f6;
  font-size: 11px;
}

.album-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.album-card {
  min-width: 0;
  padding: 10px;
  border: 1px solid #e0e6e8;
  border-radius: 7px;
  background: #fff;
}

.album-thumb {
  position: relative;
  height: 112px;
  margin-bottom: 10px;
  border: 1px solid var(--panel-border);
  border-radius: 5px;
  background: linear-gradient(135deg, #fbf1d7, var(--accent-soft));
}

.album-thumb span {
  position: absolute;
  display: block;
  border: 1px solid rgba(80, 90, 95, 0.2);
  background: rgba(255, 255, 255, 0.74);
}

.album-thumb span:nth-child(1) {
  left: 18px;
  top: 22px;
  width: 54px;
  height: 44px;
}

.album-thumb span:nth-child(2) {
  right: 20px;
  top: 34px;
  width: 48px;
  height: 38px;
}

.album-thumb span:nth-child(3) {
  left: 56px;
  bottom: 18px;
  width: 62px;
  height: 28px;
}

.album-card strong {
  display: inline-block;
  margin-top: 9px;
  color: var(--accent-strong);
  font-family: var(--font-retro);
  font-size: 11px;
}

.photo-album-editor,
.photo-editor {
  background: var(--panel-alt-bg);
}

.setting-form--photo,
.photo-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 11px;
}

.album-rail {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.album-rail button {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: auto auto;
  gap: 4px 8px;
  min-height: 58px;
  padding: 8px 9px;
  border: 1px solid var(--panel-border);
  border-radius: 5px;
  color: var(--text);
  background: #fff;
  text-align: left;
}

.album-rail button.is-active {
  border-color: var(--accent-strong);
  background: var(--accent-soft);
}

.album-rail span,
.album-rail strong,
.album-rail small,
.album-rail i {
  min-width: 0;
  font-family: var(--font-retro);
  font-size: 11px;
  font-style: normal;
}

.album-rail span {
  overflow: hidden;
  color: var(--heading-color);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.album-rail strong {
  color: var(--danger);
  text-align: right;
}

.album-rail small {
  color: var(--accent-strong);
}

.album-rail i {
  color: var(--muted-text);
  text-align: right;
}

.photo-board {
  display: grid;
  grid-template-columns: minmax(0, 0.98fr) minmax(300px, 1.02fr);
  gap: 12px;
  align-items: start;
}

.photo-grid {
  display: grid;
  gap: 10px;
}

.photo-tile {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr) 54px;
  gap: 10px;
  min-width: 0;
  padding: 9px;
  border: 1px solid #e0e6e8;
  border-radius: 5px;
  background: #fff;
  transition: border-color 120ms ease, background-color 120ms ease;
}

.photo-tile.is-selected {
  border-color: var(--accent-strong);
  background: var(--accent-soft);
}

.photo-tile__preview {
  width: 112px;
  height: 84px;
  padding: 0;
  overflow: hidden;
  border: 1px solid var(--panel-border);
  border-radius: 4px;
  background: #fff;
}

.photo-tile__preview img,
.photo-detail__frame img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-placeholder {
  position: relative;
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  min-height: 84px;
  overflow: hidden;
  color: var(--accent-strong);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.72), rgba(255, 255, 255, 0.22)), linear-gradient(145deg, #fbf1d7, var(--accent-soft));
}

.photo-placeholder span {
  position: absolute;
  inset: 14px 18px;
  border: 1px solid rgba(80, 90, 95, 0.22);
  background: rgba(255, 255, 255, 0.54);
  transform: rotate(-2deg);
}

.photo-placeholder strong {
  position: relative;
  z-index: 1;
  max-width: 80%;
  overflow-wrap: anywhere;
  font-family: var(--font-retro);
  font-size: 11px;
  text-align: center;
}

.photo-placeholder--large {
  min-height: 210px;
}

.photo-tile__body {
  min-width: 0;
}

.photo-tile h4,
.photo-detail h4 {
  margin: 0;
  color: var(--heading-color);
  font-size: 14px;
  line-height: 1.35;
}

.photo-tile p,
.photo-caption {
  display: -webkit-box;
  overflow: hidden;
  margin: 5px 0;
  color: var(--muted-text);
  font-size: 12px;
  line-height: 1.5;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.photo-tile small {
  color: var(--accent-strong);
  font-family: var(--font-retro);
  font-size: 11px;
}

.photo-tile__actions {
  display: grid;
  align-content: start;
  gap: 6px;
}

.photo-tile__actions button {
  width: 100%;
  height: 28px;
  border: 1px solid var(--panel-border);
  border-radius: 4px;
  color: var(--muted-text);
  background: #f6f6f6;
  font-family: var(--font-retro);
  font-size: 11px;
}

.photo-detail {
  min-width: 0;
  min-height: 360px;
  padding: 14px;
  border: 1px solid var(--panel-border);
  border-radius: 5px;
  background: linear-gradient(#ffffff, #fffdf7);
}

.photo-detail header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 10px;
  border-bottom: 1px dotted var(--panel-border);
}

.photo-detail time {
  color: var(--accent-strong);
  font-family: var(--font-retro);
  font-size: 11px;
}

.photo-detail__frame {
  height: 230px;
  margin: 12px 0;
  overflow: hidden;
  border: 1px solid var(--panel-border);
  border-radius: 4px;
  background: #fff;
}

.photo-caption {
  display: block;
  min-height: 58px;
  padding: 10px;
  border: 1px solid #edf0f1;
  border-radius: 4px;
  color: var(--text);
  background: #fff;
  white-space: pre-line;
}

.photo-file-access {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 10px 0 0;
}

.photo-file-access div {
  min-width: 0;
  padding: 7px;
  border: 1px solid #edf0f1;
  border-radius: 4px;
  background: #fff;
}

.photo-file-access dt,
.photo-file-access dd {
  margin: 0;
  overflow-wrap: anywhere;
  font-family: var(--font-retro);
  font-size: 11px;
}

.photo-file-access dt {
  color: var(--muted-text);
}

.photo-file-access dd {
  margin-top: 4px;
  color: var(--accent-strong);
}

.visitor-note {
  padding: 11px 12px;
  border-color: #dfd1b6;
  background: linear-gradient(#fffdf6 31px, rgba(228, 208, 166, 0.42) 32px), #fffdf6;
  background-size: 100% 32px;
  box-shadow: 0 2px 0 rgba(185, 159, 108, 0.12);
}

.visitor-note header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 5px;
}

.visitor-note header > div {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 7px;
}

.visitor-note strong {
  color: var(--accent-strong);
  font-size: 13px;
}

.visitor-note time {
  color: var(--muted-text);
  font-family: var(--font-retro);
  font-size: 11px;
}

.visitor-note.is-hidden {
  opacity: 0.66;
  background: linear-gradient(#f3f1ea 31px, rgba(190, 182, 166, 0.45) 32px), #f3f1ea;
  background-size: 100% 32px;
}

.visitor-note__status {
  padding: 2px 5px;
  border: 1px solid rgba(120, 130, 135, 0.22);
  border-radius: 3px;
  color: var(--muted-text);
  background: rgba(255, 255, 255, 0.72);
  font-family: var(--font-retro);
  font-size: 10px;
}

.visitor-note__actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  padding-top: 4px;
}

.visitor-note__actions button {
  height: 24px;
  min-width: 46px;
  border: 1px solid #d9ceb8;
  border-radius: 3px;
  color: #7a6b50;
  background: #fffaf0;
  font-family: var(--font-retro);
  font-size: 10px;
}

.guestbook-compose {
  background: #fffaf0;
}

.guestbook-access-note,
.guestbook-closed-note {
  margin: 0 0 9px;
  color: var(--muted-text);
  font-size: 12px;
  line-height: 1.5;
}

.guestbook-paper {
  display: grid;
  gap: 7px;
  padding: 12px;
  border: 1px solid #dacaa7;
  border-radius: 4px;
  background: linear-gradient(#fffdf7 31px, rgba(224, 203, 162, 0.46) 32px), #fffdf7;
  background-size: 100% 32px;
}

.guestbook-paper label {
  color: #9a7b42;
  font-family: var(--font-retro);
  font-size: 11px;
}

.guestbook-paper textarea {
  width: 100%;
  min-height: 104px;
  resize: vertical;
  border: 1px solid #d8c79f;
  border-radius: 3px;
  padding: 9px;
  color: var(--text);
  background: rgba(255, 255, 255, 0.74);
  font-size: 12px;
  line-height: 1.55;
}

.field input::placeholder,
.field textarea::placeholder,
.guestbook-paper textarea::placeholder {
  color: rgba(122, 139, 145, 0.78);
}

.guestbook-compose__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.guestbook-compose__footer span {
  color: #9a7b42;
  font-family: var(--font-retro);
  font-size: 10px;
}

.moderation-panel {
  background: #fffdf8;
}

.moderation-list {
  display: grid;
  gap: 8px;
}

.moderation-row {
  display: grid;
  gap: 7px;
  padding: 10px;
  border: 1px solid #d9ceb8;
  border-radius: 5px;
  background: #ffffff;
}

.moderation-row header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.moderation-row strong,
.moderation-row small,
.moderation-row time {
  font-family: var(--font-retro);
}

.moderation-row strong {
  display: block;
  color: var(--heading-color);
  font-size: 12px;
}

.moderation-row span,
.moderation-row time,
.moderation-row small {
  color: var(--muted-text);
  font-size: 10px;
}

.moderation-row p {
  margin: 0;
  color: var(--text);
  font-size: 12px;
  line-height: 1.5;
}

.moderation-row__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.moderation-row__actions button {
  min-height: 24px;
  border: 1px solid #d2c2a1;
  border-radius: 3px;
  color: #685d49;
  background: #fff8e9;
  font-family: var(--font-retro);
  font-size: 10px;
}

.moderation-row__actions button:disabled {
  cursor: not-allowed;
  opacity: 0.56;
}

.theme-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
}

.theme-grid .empty-note,
.miniroom-background-grid .empty-note {
  grid-column: 1/-1;
}

.theme-card {
  display: grid;
  justify-items: start;
  gap: 6px;
  min-height: 76px;
  padding: 10px;
  border: 1px solid var(--panel-border);
  border-radius: 7px;
  color: var(--text);
  background: #fff;
}

.theme-card.is-active {
  border-color: var(--accent-strong);
  box-shadow: inset 0 0 0 2px var(--accent-soft);
}

.theme-card__swatch {
  width: 34px;
  height: 18px;
  border: 1px solid rgba(0, 0, 0, 0.16);
  border-radius: 3px;
  background: var(--accent);
}

.theme-card strong {
  font-family: var(--font-retro);
  font-size: 12px;
}

.theme-card small {
  color: var(--muted-text);
  font-size: 11px;
}

.miniroom-background-setting {
  background: var(--panel-alt-bg);
}

.miniroom-register-form {
  margin-bottom: 8px;
}

.miniroom-upload-field input[type=file] {
  width: 100%;
  min-width: 0;
  font-size: 11px;
}

.field-help {
  display: block;
  margin-top: 4px;
  color: var(--muted-text);
  font-size: 10px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.field-help--wrap {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.inline-alert,
.empty-note,
.save-status,
.guestbook-access-note,
.guestbook-closed-note,
.diary-detail__content,
.photo-caption {
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.miniroom-form-actions {
  margin-bottom: 12px;
}

.miniroom-setting-row {
  display: grid;
  grid-template-columns: minmax(180px, 240px) auto;
  gap: 10px;
  align-items: end;
  margin-bottom: 12px;
}

.miniroom-background-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  max-height: 430px;
  overflow: auto;
  padding-right: 2px;
}

.miniroom-background-card {
  display: grid;
  gap: 6px;
  min-width: 0;
  padding: 7px;
  border: 1px solid var(--panel-border);
  border-radius: 5px;
  color: var(--text);
  background: #fff;
  text-align: left;
}

.miniroom-background-card.is-active {
  border-color: var(--accent-strong);
  background: var(--accent-soft);
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.72);
}

.miniroom-background-card:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.miniroom-background-thumb {
  display: grid;
  place-items: center;
  width: 100%;
  aspect-ratio: 5/3;
  overflow: hidden;
  border: 1px solid var(--panel-border);
  border-radius: 3px;
  background: #f7f7f7;
}

.miniroom-background-thumb img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.miniroom-background-card strong,
.miniroom-background-card small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.miniroom-background-card strong {
  color: var(--heading-color);
  font-family: var(--font-retro);
  font-size: 11px;
}

.miniroom-background-card small {
  color: var(--muted-text);
  font-family: var(--font-retro);
  font-size: 10px;
}

.inline-alert,
.empty-note,
.save-status {
  margin: 0;
  color: var(--muted-text);
  font-size: 12px;
  line-height: 1.5;
}

.inline-alert {
  margin-bottom: 10px;
  padding: 8px 10px;
  border: 1px solid var(--panel-border);
  border-radius: 5px;
  background: var(--panel-alt-bg);
}

.inline-alert.is-error {
  border-color: rgba(204, 52, 52, 0.35);
  color: var(--danger);
  background: #fff5f5;
}

.mini-link-button,
.primary-action,
.secondary-action,
.diary-entry__actions button {
  height: 28px;
  border: 1px solid var(--panel-border);
  border-radius: 4px;
  font-family: var(--font-retro);
  font-size: 11px;
}

.mini-link-button {
  min-width: 44px;
  padding: 0 9px;
  color: var(--accent-strong);
  background: var(--accent-soft);
}

.Miniroom .section-head .mini-link-button {
  position: relative;
  top: -7px;
}

.setting-form,
.diary-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 11px;
}

.setting-form--compact {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.field,
.toggle-field {
  display: grid;
  gap: 5px;
  min-width: 0;
}

.field--wide {
  grid-column: span 2;
}

.field--full {
  grid-column: 1/-1;
}

.field span,
.toggle-field span {
  color: var(--accent-strong);
  font-family: var(--font-retro);
  font-size: 11px;
}

.field input,
.field select,
.field textarea {
  width: 100%;
  min-width: 0;
  border: 1px solid var(--panel-border);
  border-radius: 4px;
  color: var(--text);
  background: #fff;
  font-size: 12px;
  line-height: 1.4;
}

.field input,
.field select {
  height: 32px;
  padding: 0 8px;
}

.field textarea {
  resize: vertical;
  min-height: 92px;
  padding: 8px;
}

.field input:disabled,
.field select:disabled,
.field textarea:disabled,
.toggle-field input:disabled + span {
  color: var(--muted-text);
  background: #f4f4f4;
}

.toggle-field {
  align-content: end;
  grid-template-columns: 16px minmax(0, 1fr);
  align-items: center;
  min-height: 32px;
  padding-top: 17px;
}

.toggle-field input {
  width: 14px;
  height: 14px;
  accent-color: var(--accent);
}

.form-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}

.primary-action,
.secondary-action {
  min-width: 82px;
  padding: 0 12px;
}

.primary-action {
  border-color: var(--accent-strong);
  color: #fff;
  background: var(--accent);
}

.secondary-action {
  color: var(--muted-text);
  background: #f7f7f7;
}

.primary-action:disabled,
.secondary-action:disabled,
.theme-card:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.diary-editor {
  background: var(--panel-alt-bg);
}

.diary-monthly {
  background: #fffdf7;
}

.diary-month-rail {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.diary-month-rail button {
  display: inline-grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  min-width: 116px;
  height: 32px;
  padding: 0 9px;
  border: 1px solid var(--panel-border);
  border-radius: 4px;
  color: var(--text);
  background: #fff;
  font-family: var(--font-retro);
  font-size: 11px;
}

.diary-month-rail button.is-active {
  border-color: var(--accent-strong);
  color: var(--accent-strong);
  background: var(--accent-soft);
}

.diary-month-rail strong {
  color: var(--danger);
  font-size: 12px;
}

.diary-board {
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(280px, 1.05fr);
  gap: 12px;
  align-items: start;
}

.diary-entry {
  grid-template-columns: 64px minmax(0, 1fr) 92px;
  align-items: start;
  border-radius: 4px;
  transition: border-color 120ms ease, background-color 120ms ease;
}

.diary-entry.is-selected {
  border-color: var(--accent-strong);
  background: var(--accent-soft);
}

.diary-entry__body {
  min-width: 0;
}

.diary-entry__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.diary-entry__head span,
.diary-entry__body small {
  color: var(--accent-strong);
  font-family: var(--font-retro);
  font-size: 11px;
}

.diary-entry__body p {
  margin: 0 0 6px;
  color: var(--muted-text);
  font-size: 12px;
  line-height: 1.55;
}

.diary-entry__actions {
  display: grid;
  gap: 6px;
}

.diary-entry__actions button {
  width: 100%;
  color: var(--muted-text);
  background: #f6f6f6;
}

.diary-detail {
  min-width: 0;
  min-height: 280px;
  padding: 14px;
  border: 1px solid var(--panel-border);
  border-radius: 5px;
  background: linear-gradient(#ffffff, #fffdf7);
}

.diary-detail header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 10px;
  border-bottom: 1px dotted var(--panel-border);
}

.diary-detail h4 {
  margin: 6px 0 0;
  color: var(--heading-color);
  font-size: 15px;
  line-height: 1.35;
}

.diary-detail time,
.diary-detail__meta,
.mood-badge {
  color: var(--accent-strong);
  font-family: var(--font-retro);
  font-size: 11px;
}

.mood-badge {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 0 8px;
  border: 1px solid var(--panel-border);
  border-radius: 999px;
  background: var(--accent-soft);
}

.diary-detail__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0;
  color: var(--muted-text);
}

.diary-detail__content {
  min-height: 132px;
  margin: 0;
  padding: 12px;
  border: 1px solid #edf0f1;
  border-radius: 4px;
  color: var(--text);
  background: #ffffff;
  font-size: 13px;
  line-height: 1.7;
  white-space: pre-line;
}

.diary-detail__actions {
  display: flex;
  gap: 7px;
  justify-content: flex-end;
  margin-top: 10px;
}

.diary-detail__actions button {
  height: 28px;
  min-width: 54px;
  border: 1px solid var(--panel-border);
  border-radius: 4px;
  color: var(--muted-text);
  background: #f6f6f6;
  font-family: var(--font-retro);
  font-size: 11px;
}

.TabNavigation {
  position: absolute;
  top: 122px;
  right: calc(var(--window-pad-x) - var(--tab-width) + 1px);
  z-index: 4;
  display: grid;
  gap: 5px;
  width: var(--tab-width);
}

.TabNavigation button {
  position: relative;
  z-index: 1;
  width: var(--tab-width);
  height: var(--tab-height);
  padding: 0 10px 0 18px;
  border: 1px solid var(--tab-border);
  border-left-color: var(--panel-border);
  border-radius: 0 9px 9px 0;
  color: var(--tab-text);
  background: var(--tab-bg);
  box-shadow: none;
  font-family: var(--font-retro);
  font-size: 14px;
  font-weight: 400;
  text-align: left;
}

.TabNavigation button.is-tracked-label span {
  letter-spacing: 0.06em;
}

.TabNavigation button.is-active {
  color: var(--tab-active-text);
  background: var(--tab-active-bg);
  border-color: var(--tab-active-border);
  border-left-color: var(--panel-border);
  box-shadow: none;
  transform: none;
}

.TabNavigation button:focus-visible,
.theme-chip:focus-visible,
.theme-card:focus-visible,
.bgm-controls button:focus-visible {
  outline: 2px solid var(--danger);
  outline-offset: 2px;
}

.RightWidgetPanel {
  flex: 0 0 var(--right-widget-width);
  width: var(--right-widget-width);
  min-height: 360px;
  margin-top: 8px;
  border: 1px solid var(--shell-border);
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 18px 34px var(--shadow);
  padding: 10px;
}

.widget-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  margin-bottom: 8px;
}

.widget-tabs button {
  height: 30px;
  border: 1px solid var(--panel-border);
  border-radius: 5px 5px 0 0;
  color: var(--muted-text);
  background: #eef2f3;
  font-family: var(--font-retro);
  font-size: 11px;
}

.widget-tabs button.is-active {
  color: var(--accent-strong);
  background: #fff;
  border-bottom-color: #fff;
}

.widget-card,
.widget-counts,
.widget-strip {
  border: 1px solid var(--panel-border);
  border-radius: 7px;
  background: #fff;
}

.widget-card {
  padding: 12px;
  margin-bottom: 9px;
}

.widget-card h2,
.bgm-title {
  margin: 0 0 7px;
  color: var(--heading-color);
  font-family: var(--font-retro);
  font-size: 13px;
}

.friend-card button {
  width: 100%;
  margin-top: 10px;
}

.widget-auth-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  margin-top: 8px;
}

.widget-auth-actions button {
  min-width: 0;
  margin-top: 0;
  padding-inline: 4px;
}

.widget-counts {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 9px;
  overflow: hidden;
}

.widget-counts div {
  min-width: 0;
  padding: 8px 4px;
  border-right: 1px solid var(--panel-border);
  text-align: center;
}

.widget-counts div:last-child {
  border-right: 0;
}

.widget-counts span,
.widget-counts strong {
  display: block;
}

.widget-counts span {
  color: var(--muted-text);
  font-size: 11px;
}

.widget-counts strong {
  margin-top: 2px;
  color: var(--accent-strong);
  font-family: var(--font-retro);
  font-size: 15px;
}

.bgm-title {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.bgm-title span {
  color: var(--accent-strong);
}

.bgm-title strong {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}

.bgm-controls {
  display: grid;
  grid-template-columns: 62px 48px minmax(0, 1fr);
  gap: 8px;
  align-items: center;
  margin: 10px 0 8px;
}

.bgm-controls button {
  height: 28px;
  border: 1px solid var(--accent-strong);
  border-radius: 4px;
  color: #fff;
  background: var(--accent);
  font-family: var(--font-retro);
  font-size: 11px;
}

.bgm-controls button.is-playing {
  color: var(--accent-strong);
  background: var(--accent-soft);
}

.bgm-volume-value {
  color: var(--muted-text);
  font-family: var(--font-retro);
  font-size: 10px;
  text-align: right;
}

.bgm-controls input {
  width: 100%;
  accent-color: var(--accent);
}

.widget-strip {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 8px;
}

.widget-strip button {
  width: 100%;
}

.widget-strip button.is-active {
  border-color: var(--accent-strong);
  color: var(--accent-strong);
  background: var(--accent-soft);
}

.shop-balance {
  background: #fffdf7;
}

.shop-note {
  margin: 0;
  color: var(--muted-text);
  font-size: var(--content-small-font-size);
}

.shop-section {
  background: #fff;
}

.shop-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.shop-card {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr);
  gap: 10px;
  min-height: 120px;
  padding: 9px;
  border: 1px solid var(--panel-border);
  border-radius: 6px;
  background: #fff;
}

.shop-card.is-owned {
  border-color: var(--accent-strong);
  background: var(--accent-soft);
}

.shop-card.is-current {
  box-shadow: inset 0 0 0 1px var(--accent-strong);
}

.shop-card.is-admin {
  border-style: dashed;
}

.shop-card__preview {
  overflow: hidden;
  min-width: 0;
  height: 78px;
  border: 1px solid var(--panel-border);
  border-radius: 5px;
  background: #f6f6f6;
}

.shop-card__preview--theme {
  display: grid;
  place-items: center;
}

.shop-card__preview--theme span {
  display: block;
  width: 52px;
  height: 42px;
  border: 1px solid rgba(80, 90, 95, 0.24);
  border-radius: 4px;
  background: linear-gradient(135deg, var(--accent-soft), #fff);
}

.shop-card__preview--theme[data-theme-preview=sky] {
  background: #d7f2f7;
}

.shop-card__preview--theme[data-theme-preview=gray] {
  background: #e7e7e7;
}

.shop-card__preview--theme[data-theme-preview=blossom],
.shop-card__preview--theme[data-theme-preview=blush],
.shop-card__preview--theme[data-theme-preview=pastel-pink] {
  background: #f9e2e8;
}

.shop-card__preview--theme[data-theme-preview=navy] {
  background: #dfe6f2;
}

.shop-card__preview--theme[data-theme-preview=mono] {
  background: #f2f2f2;
}

.shop-card__preview--theme[data-theme-preview=red-black] {
  background: #2c2c2c;
}

.shop-card__preview--theme[data-theme-preview=pastel-blue] {
  background: #dfefff;
}

.shop-card__preview--theme[data-theme-preview=pastel-green] {
  background: #e1f0dc;
}

.shop-card__preview--image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform: none;
  background: #fff;
}

.shop-card__body {
  display: grid;
  grid-template-rows: auto auto auto auto;
  gap: 5px;
  min-width: 0;
}

.shop-card__body h4,
.shop-card__body p {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shop-card__body h4 {
  color: var(--heading-color);
  font-size: var(--content-card-title-font-size);
}

.shop-card__body p {
  color: var(--muted-text);
  font-family: var(--font-retro);
  font-size: var(--content-micro-font-size);
}

.shop-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
}

.shop-card__meta strong,
.shop-card__meta span {
  padding: 3px 6px;
  border: 1px solid var(--panel-border);
  border-radius: 4px;
  background: #fff;
  font-family: var(--font-retro);
  font-size: 11px;
  font-weight: 400;
}

.shop-card__meta strong {
  color: var(--danger);
}

.shop-card__meta span {
  color: var(--accent-strong);
}

.shop-action {
  width: 100%;
  height: 28px;
  border: 1px solid var(--panel-border);
  border-radius: 4px;
  color: var(--muted-text);
  background: #f6f6f6;
  font-size: 11px;
}

.profile-nameplate,
.profile-box,
.profile-select,
.mini-section,
.review-item,
.summary-row,
.info-list,
.setting-list,
.ilchon-row,
.album-card,
.album-rail button,
.photo-tile,
.photo-detail,
.photo-file-access,
.visitor-note,
.guestbook-paper,
.moderation-row,
.theme-card,
.miniroom-background-card,
.shop-card,
.widget-card,
.widget-counts,
.widget-strip {
  letter-spacing: var(--content-letter-spacing);
}

.profile-label,
.profile-select label,
.profile-box h3,
.section-head span,
.room-caption,
.review-date,
.summary-row span,
.info-list dt,
.setting-list dt,
.tag-row span,
.ilchon-lane h4,
.ilchon-row span,
.album-card strong,
.album-rail span,
.album-rail strong,
.album-rail small,
.album-rail i,
.photo-placeholder strong,
.photo-tile small,
.photo-detail time,
.photo-file-access dt,
.photo-file-access dd,
.visitor-note time,
.guestbook-paper label,
.theme-card small,
.moderation-row strong,
.miniroom-background-card strong,
.field span,
.toggle-field span,
.diary-month-rail button,
.diary-entry time,
.diary-entry__head span,
.diary-entry__body small,
.diary-detail time,
.diary-detail__meta,
.mood-badge,
.widget-tabs button,
.widget-counts span {
  font-size: var(--content-small-font-size);
  letter-spacing: var(--content-retro-letter-spacing);
}

.profile-nameplate p,
.profile-box p,
.profile-select select,
.content-titlebar p,
.review-item p,
.diary-entry p,
.album-card p,
.visitor-note p,
.paragraph,
.bgm-card p,
.friend-card p,
.summary-row strong,
.info-list dd,
.setting-list dd,
.ilchon-row strong,
.guestbook-access-note,
.guestbook-closed-note,
.guestbook-paper textarea,
.moderation-row p,
.field input,
.field select,
.field textarea,
.diary-entry__body p,
.photo-tile p,
.photo-caption,
.inline-alert,
.empty-note,
.save-status {
  font-size: var(--content-body-font-size);
  letter-spacing: var(--content-letter-spacing);
}

.profile-nameplate h2 {
  font-size: var(--content-profile-name-font-size);
  letter-spacing: var(--content-retro-letter-spacing);
}

.section-head h3,
.mini-section h3,
.review-item h4,
.diary-entry h4,
.album-card h4,
.visitor-note strong,
.theme-card strong,
.widget-card h2 {
  font-size: var(--content-card-title-font-size);
  letter-spacing: var(--content-retro-letter-spacing);
}

.photo-tile h4,
.photo-detail h4,
.diary-detail h4 {
  font-size: var(--content-detail-title-font-size);
  letter-spacing: var(--content-retro-letter-spacing);
}

.diary-detail__content {
  font-size: var(--content-detail-body-font-size);
  letter-spacing: var(--content-letter-spacing);
}

.diary-entry button,
.friend-card button,
.widget-strip button,
.ilchon-row__actions button,
.photo-tile__actions button,
.visitor-note__actions button,
.moderation-row__actions button,
.mini-link-button,
.primary-action,
.secondary-action,
.diary-entry__actions button,
.diary-detail__actions button,
.bgm-controls button {
  font-size: var(--content-small-font-size);
  letter-spacing: var(--content-button-letter-spacing);
}

.widget-counts strong {
  font-size: var(--content-widget-count-font-size);
  letter-spacing: var(--content-retro-letter-spacing);
}

.bgm-title,
.bgm-title strong {
  font-size: var(--content-card-title-font-size);
  letter-spacing: var(--content-retro-letter-spacing);
}

.bgm-volume-value,
.guestbook-compose__footer span,
.visitor-note__status,
.moderation-row span,
.moderation-row time,
.moderation-row small,
.miniroom-background-card small {
  font-size: var(--content-micro-font-size);
  letter-spacing: var(--content-retro-letter-spacing);
}

.review-date,
.diary-entry time {
  place-self: stretch;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 100%;
  text-align: center;
  line-height: 1.35;
}

.photo-tile small {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  line-height: 1.35;
}

@media (max-width: 1500px) {
  .ThemeProvider {
    --workspace-gap: 70px;
  }
  .theme-quick-switch {
    top: 8px;
    right: 14px;
  }
  .minihompy-viewport {
    justify-content: flex-start;
    padding-left: 20px;
    padding-right: 20px;
  }
  .minihompy-workspace {
    gap: var(--workspace-gap);
  }
}
@media (max-width: 900px) {
  .theme-quick-switch {
    position: sticky;
    top: 0;
    right: auto;
    max-width: calc(100vw - 24px);
    margin: 0 12px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
  }
  .theme-chip {
    flex: 0 0 auto;
  }
  .minihompy-viewport {
    min-width: 0;
    align-items: flex-start;
    padding: 16px 12px 28px;
    overscroll-behavior-x: contain;
    -webkit-overflow-scrolling: touch;
  }
  .scroll-affordance {
    position: fixed;
    top: 46px;
    bottom: 26px;
    z-index: 18;
    display: block;
    width: 46px;
    pointer-events: none;
    opacity: 0.88;
  }
  .scroll-affordance--right {
    right: 0;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.28) 45%, rgba(255, 255, 255, 0.08));
    box-shadow: inset -10px 0 18px var(--window-shadow);
  }
  .scroll-affordance--right::before,
  .scroll-affordance--right::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 14px;
    width: 10px;
    height: 10px;
    border-top: 2px solid var(--accent-strong);
    border-right: 2px solid var(--accent-strong);
    transform: rotate(45deg);
  }
  .scroll-affordance--right::before {
    margin-top: -16px;
    opacity: 0.48;
  }
  .scroll-affordance--right::after {
    margin-top: 4px;
    opacity: 0.78;
  }
  .field textarea {
    min-height: 112px;
  }
  .guestbook-paper textarea {
    min-height: 120px;
  }
  .form-actions,
  .diary-entry__actions,
  .photo-tile__actions,
  .visitor-note__actions,
  .diary-detail__actions,
  .miniroom-form-actions {
    gap: 10px;
  }
  .mini-link-button,
  .primary-action,
  .secondary-action,
  .diary-entry__actions button,
  .photo-tile__actions button,
  .visitor-note__actions button,
  .diary-detail__actions button,
  .bgm-controls button {
    min-height: 32px;
    touch-action: manipulation;
  }
  .field input:focus-visible,
  .field select:focus-visible,
  .field textarea:focus-visible,
  .guestbook-paper textarea:focus-visible,
  .miniroom-background-card:focus-visible {
    outline: 2px solid var(--danger);
    outline-offset: 2px;
  }
}`],
})
export class PageDashboardComponent implements OnInit, OnDestroy {
    public activeTab: MinihompyTab = 'Home';
    public activeTheme: MinihompyThemeId = 'sky';
    public slug: string = 'jiwon';
    public isBgmPlaying: boolean = false;
    public bgmVolume: number = 72;
    public bgmStatusMessage: string = '클릭 후 재생 대기';
    public isLoading: boolean = true;
    public authGateReady: boolean = false;
    public authGateRedirecting: boolean = false;
    public isShopOpen: boolean = false;
    public isLoadingShop: boolean = false;
    public isPurchasingShopItem: boolean = false;
    public purchasingShopItemId: string = '';
    public isSavingSettings: boolean = false;
    public isSavingDiary: boolean = false;
    public isSavingRelationship: boolean = false;
    public isSavingGuestbook: boolean = false;
    public isReporting: boolean = false;
    public isSavingModeration: boolean = false;
    public settingsMessage: string = '';
    public diaryMessage: string = '';
    public relationshipMessage: string = '';
    public guestbookMessage: string = '';
    public moderationMessage: string = '';
    public shopMessage: string = '';
    public shopPointBalanceLabel: string = 'POINT 잔액';
    public loadError: string = '';

    public readonly defaultSlug: string = 'jiwon';

    public readonly themes: ThemeMeta[] = [
        { id: 'sky', label: 'sky', tone: '하늘색' },
        { id: 'gray', label: 'gray', tone: '회색' },
        { id: 'blossom', label: 'blossom', tone: '연회색 / 연핑크 탭' },
        { id: 'blush', label: 'blush', tone: '분홍' },
        { id: 'navy', label: 'navy', tone: '남색' },
        { id: 'mono', label: 'mono', tone: '흑백' },
        { id: 'red-black', label: 'red-black', tone: '검빨' },
        { id: 'pastel-pink', label: 'pastel-pink', tone: '파스텔 분홍' },
        { id: 'pastel-blue', label: 'pastel-blue', tone: '파스텔 파랑' },
        { id: 'pastel-green', label: 'pastel-green', tone: '파스텔 초록' }
    ];

    public readonly tabs: TabMeta[] = [
        { id: 'Home', slug: 'home', label: 'Home', title: '오늘의 작은 방', description: '기록장과 미니룸이 잠깐 열린 작은 방입니다.' },
        { id: 'Profile', slug: 'profile', label: 'Profile', title: '프로필', description: '방 주인의 소개와 오늘의 말이 놓인 자리입니다.' },
        { id: 'Diary', slug: 'diary', label: 'Diary', title: '다이어리', description: '날짜별로 접어 둔 기억장입니다.' },
        { id: 'Photo', slug: 'photo', label: 'Photo', title: '사진첩', description: '앨범 속 사진을 조용히 보관합니다.' },
        { id: 'Visitor', slug: 'visitor', label: 'Visitor', title: '방명록', description: '방문자가 남긴 짧은 흔적' },
        { id: 'Setting', slug: 'setting', label: 'Setting', title: '설정', description: '방 꾸밈과 공개 범위를 보관합니다.' }
    ];

    public readonly visibilityOptions: { value: Visibility; label: string }[] = [
        { value: 'PUBLIC', label: '전체 공개' },
        { value: 'ILCHON', label: '일촌 공개' },
        { value: 'PRIVATE', label: '나만 보기' }
    ];

    public readonly photoVisibilityOptions: { value: PhotoVisibilityFormValue; label: string }[] = [
        { value: 'INHERIT', label: '앨범 기본' },
        { value: 'PUBLIC', label: '전체 공개' },
        { value: 'ILCHON', label: '일촌 공개' },
        { value: 'PRIVATE', label: '나만 보기' }
    ];

    public readonly guestbookPolicyOptions: { value: GuestbookPolicy; label: string }[] = [
        { value: 'AUTHENTICATED', label: '전체 로그인 사용자' },
        { value: 'ILCHON', label: '일촌만' },
        { value: 'OWNER', label: '닫기' }
    ];

    public readonly miniroomFitOptions: { value: MiniroomBackgroundFit; label: string }[] = [
        { value: 'contain', label: 'contain' }
    ];

    public readonly miniroomUploadAccept: string = 'image/png,image/jpeg,image/gif,.png,.jpg,.jpeg,.gif';
    public readonly miniroomUploadMaxBytes: number = 5 * 1024 * 1024;

    public readonly miniroomMimeOptions: { value: string; label: string }[] = [
        { value: 'image/jpeg', label: 'JPEG' },
        { value: 'image/png', label: 'PNG' },
        { value: 'image/gif', label: 'GIF' }
    ];

    public readonly photoMimeOptions: { value: string; label: string }[] = [
        { value: 'image/jpeg', label: 'JPEG' },
        { value: 'image/png', label: 'PNG' },
        { value: 'image/gif', label: 'GIF' }
    ];

    public readonly moderationStatusOptions: { value: ModerationStatus; label: string }[] = [
        { value: 'PENDING_REVIEW', label: '검토 대기' },
        { value: 'HIDDEN_BY_MODERATOR', label: '관리자 숨김' },
        { value: 'DELETED', label: '삭제' }
    ];

    public visit = {
        today: 128,
        total: 48219
    };

    public minihompy: MinihompyProfile = this.createDefaultMinihompy();

    public profile: ProfileViewModel = {
        name: '김지원',
        title: 'Recollections',
        status: '작은 기억을 천천히 정리하는 중입니다.',
        history: '2026.05.26 - 작은 방을 다시 정리한 날',
        mood: '오늘의 기분을 고르는 중',
        bio: '느린 기록, 사진, 방명록을 천천히 모아두는 작은 웹 방입니다.',
        profileImageUrl: ''
    };

    public diaryEntries: DiaryEntry[] = [];
    public photoAlbums: PhotoAlbum[] = [];
    public photos: PhotoItem[] = [];
    public miniroomBackgrounds: MiniroomBackground[] = [];
    public ownedThemes: ThemeMeta[] = [];
    public ownedMiniroomBackgrounds: MiniroomBackground[] = [];
    public shopItems: ShopItem[] = [];
    public shopThemeItems: ShopItem[] = [];
    public shopMiniroomBackgroundItems: ShopItem[] = [];
    public miniroomBackgroundForm: MiniroomBackgroundForm = this.createEmptyMiniroomBackgroundForm();
    public isSavingMiniroomBackground: boolean = false;
    public miniroomBackgroundMessage: string = '';
    public miniroomUploadFile: File | null = null;
    public miniroomUploadProgress: number = 0;
    public visitors: GuestbookEntry[] = [];
    public relationship: RelationshipContext = this.createDefaultRelationship();
    public ilchon: IlchonOverview = this.createDefaultIlchonOverview();
    public selectedDiary: DiaryEntry | null = null;
    public selectedDiaryMonth: string = this.currentMonth();
    public diaryDetailMessage: string = '';
    public selectedPhotoAlbumId: string = '';
    public selectedPhoto: PhotoItem | null = null;
    public photoAlbumForm: PhotoAlbumForm = this.createEmptyPhotoAlbumForm();
    public photoForm: PhotoForm = this.createEmptyPhotoForm();
    public photoAlbumEditing: boolean = false;
    public photoEditing: boolean = false;
    public isSavingPhoto: boolean = false;
    public photoMessage: string = '';
    public photoDetailMessage: string = '';

    public readonly widgetCounts = [
        { label: '댓글', value: '12' },
        { label: '앱스', value: '03' },
        { label: '스크랩', value: '07' }
    ];

    public access: AccessMatrix = {
        role: 'USER',
        isAdmin: false,
        isOwner: false,
        relationshipStatus: 'NONE',
        canViewMinihompy: true,
        canEditProfile: false,
        canCreateDiary: false,
        canCreatePhoto: false,
        canManageCatalog: false,
        canUseThemeSwitcher: false,
        canUseAllThemes: false,
        canUseAllMiniroomBackgrounds: false,
        canWriteGuestbook: false,
        canRequestIlchon: false,
        canAcceptIlchon: false,
        canDeleteIlchon: false,
        canBlockUser: false,
        canReport: false,
        canModerateReports: false
    };
    public viewer: any = { isMock: true };

    public settingsForm: SettingsForm = this.createSettingsForm(this.minihompy);
    public diaryForm: DiaryForm = this.createEmptyDiaryForm();
    public diaryEditing: boolean = false;
    public guestbookForm: GuestbookForm = this.createEmptyGuestbookForm();
    public moderation: ModerationPayload = this.createDefaultModeration();
    public moderationReports: ModerationReport[] = [];

    private routerSub: any;
    private bgmAudioContext: AudioContext | null = null;
    private bgmGain: GainNode | null = null;
    private bgmOscillator: OscillatorNode | null = null;
    private bgmPulseTimer: any = null;
    private bgmNoteIndex: number = 0;
    private readonly bgmNotePattern: number[] = [392, 440, 523.25, 440, 349.23, 392];

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {
        this.miniroomBackgrounds = this.createFallbackMiniroomBackgrounds();
        this.minihompy.selectedMiniroomBackgroundId = this.resolveMiniroomBackgroundId(
            this.minihompy.selectedMiniroomBackgroundId,
            this.miniroomBackgrounds
        );
        this.settingsForm = this.createSettingsForm(this.minihompy);
    }

    public async ngOnInit() {
        await this.service.init();
        if (!this.canEnterDashboard()) {
            this.redirectToAccess('login');
            return;
        }
        this.authGateReady = true;

        const savedTheme = window.localStorage.getItem('recollections-theme');
        if (savedTheme && this.isTheme(savedTheme)) {
            this.activeTheme = savedTheme;
        }

        this.syncRouteState();
        this.ensureCanonicalTabUrl();
        await this.loadMinihompy();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const changed = this.syncRouteState();
                this.ensureCanonicalTabUrl();
                if (changed) {
                    await this.loadMinihompy();
                } else {
                    await this.service.render();
                }
            }
        });

        await this.service.render();
    }

    public ngOnDestroy(): void {
        if (this.routerSub) this.routerSub.unsubscribe();
        this.stopBgmPlayback(true);
    }

    public get activeTabMeta(): TabMeta {
        return this.tabs.find((tab: TabMeta) => tab.id === this.activeTab) || this.tabs[0];
    }

    public get activeTabDescription(): string {
        if (this.activeTab === 'Home') {
            return `${this.profile.title} - ${this.profile.status}`;
        }
        if (this.activeTab === 'Profile') {
            return `${this.profile.name}님의 작은 소개장을 펼쳐봅니다.`;
        }
        return this.activeTabMeta.description;
    }

    public get activeContentKey(): string {
        return this.isShopOpen ? 'Shop' : this.activeTab;
    }

    public get contentTitleLabel(): string {
        return this.isShopOpen ? 'Shop' : this.activeTabMeta.label;
    }

    public get contentTitleText(): string {
        return this.isShopOpen ? '선물가게' : this.activeTabMeta.title;
    }

    public get contentTitleDescription(): string {
        if (this.isShopOpen) {
            return '테마와 미니룸 배경 catalog';
        }
        return this.activeTabDescription;
    }

    public get minihompyUrl(): string {
        return `/dashboard/${this.slug}/home`;
    }

    public get homeReviews(): HomeReviewItem[] {
        const rows: HomeReviewItem[] = [];
        for (const entry of this.diaryEntries) {
            rows.push({
                title: this.homeDiaryReviewTitle(entry),
                body: this.homeDiaryReviewBody(entry),
                date: this.reviewDisplayDate(entry.entryDate || entry.date || entry.createdAt),
                sortKey: this.reviewSortKey(entry.entryDate || entry.createdAt)
            });
        }
        for (const photo of this.photos) {
            rows.push({
                title: `Photo - ${this.fallbackText(photo.title, '이름 없는 사진')}`,
                body: this.homePhotoReviewBody(photo),
                date: this.reviewDisplayDate(photo.takenAt || photo.date || photo.createdAt),
                sortKey: this.reviewSortKey(photo.takenAt || photo.createdAt)
            });
        }
        for (const visitor of this.visitors) {
            rows.push({
                title: `Visitor - ${this.fallbackText(visitor.name, '방문자')}`,
                body: this.compactText(visitor.message || '방명록에 작은 흔적을 남겼습니다.', 82),
                date: this.reviewDisplayDate(visitor.createdAt || visitor.date),
                sortKey: this.reviewSortKey(visitor.createdAt || visitor.date)
            });
        }
        return rows.sort((a: HomeReviewItem, b: HomeReviewItem) => b.sortKey.localeCompare(a.sortKey)).slice(0, 3);
    }

    public get homeReviewLabel(): string {
        return this.homeReviews.length ? '방 안에 남은 최근 흔적' : '아직 조용한 방';
    }

    public get latestDiaryTitle(): string {
        return this.diaryEntries.length ? this.homeDiarySummaryTitle(this.diaryEntries[0]) : '첫 다이어리를 기다리고 있어요.';
    }

    public get miniroomSectionLabel(): string {
        if (this.selectedMiniroomBackground) {
            return `오늘의 배경 - ${this.miniroomBackgroundLabel(this.selectedMiniroomBackground)}`;
        }
        return '기본 프레임으로 비워둔 방';
    }

    public get miniroomFallbackCaption(): string {
        return this.profile.status || '아직 방 배경을 고르는 중';
    }

    public get selectedMiniroomBackground(): MiniroomBackground | null {
        const selectedId = this.minihompy.selectedMiniroomBackgroundId || '';
        if (!selectedId) return null;
        return this.miniroomBackgrounds.find((background: MiniroomBackground) => background.id === selectedId) || null;
    }

    public get selectedMiniroomBackgroundFit(): MiniroomBackgroundFit {
        return this.normalizeMiniroomBackgroundFit(this.minihompy.miniroomBackgroundFit);
    }

    public get diaryMonths(): DiaryMonth[] {
        const byMonth: { [key: string]: number } = {};
        for (const entry of this.diaryEntries) {
            const key = this.entryMonth(entry);
            if (!key) continue;
            byMonth[key] = (byMonth[key] || 0) + 1;
        }
        return Object.keys(byMonth).sort().reverse().map((key: string) => {
            return { key, label: this.formatDiaryMonth(key), count: byMonth[key] };
        });
    }

    public get diaryMonthLabel(): string {
        return this.selectedDiaryMonth ? this.formatDiaryMonth(this.selectedDiaryMonth) : '월별 기록';
    }

    public get filteredDiaryEntries(): DiaryEntry[] {
        if (!this.selectedDiaryMonth) return this.diaryEntries;
        return this.diaryEntries.filter((entry: DiaryEntry) => this.entryMonth(entry) === this.selectedDiaryMonth);
    }

    public get selectedDiaryEntry(): DiaryEntry | null {
        if (this.selectedDiary && this.filteredDiaryEntries.some((entry: DiaryEntry) => entry.id === this.selectedDiary?.id)) {
            return this.selectedDiary;
        }
        return this.filteredDiaryEntries[0] || null;
    }

    public get canManagePhotos(): boolean {
        return Boolean(this.access.canCreatePhoto || this.access.isOwner);
    }

    public get selectedPhotoAlbum(): PhotoAlbum | null {
        if (this.selectedPhotoAlbumId) {
            const selected = this.photoAlbums.find((album: PhotoAlbum) => album.id === this.selectedPhotoAlbumId);
            if (selected) return selected;
        }
        return this.photoAlbums[0] || null;
    }

    public get selectedAlbumPhotos(): PhotoItem[] {
        const album = this.selectedPhotoAlbum;
        if (!album) return [];
        return this.photos.filter((photo: PhotoItem) => photo.albumId === album.id);
    }

    public get selectedPhotoEntry(): PhotoItem | null {
        if (this.selectedPhoto && this.selectedAlbumPhotos.some((photo: PhotoItem) => photo.id === this.selectedPhoto?.id)) {
            return this.selectedPhoto;
        }
        return this.selectedAlbumPhotos[0] || null;
    }

    public get photoAlbumLabel(): string {
        const album = this.selectedPhotoAlbum;
        return album ? `${album.name} / ${this.formatVisibility(album.visibility)}` : '조용한 사진첩';
    }

    public get diaryListCountLabel(): string {
        const count = this.filteredDiaryEntries.length;
        return count ? `${count}장의 기록` : '오늘의 작은 기록을 기다려요';
    }

    public get latestPhotoTitle(): string {
        return this.photos.length ? this.photos[0].title : '사진첩이 아직 조용합니다.';
    }

    public get latestVisitorMessage(): string {
        return this.visitors.length ? this.visitors[0].message : '아직 남겨진 흔적이 없어요.';
    }

    public get guestbookAccessHint(): string {
        if (this.access.canWriteGuestbook) {
            return '방명록에 작은 인사를 남겨보세요.';
        }
        if (this.access.relationshipStatus === 'BLOCKED') {
            return '지금은 이 방명록에 인사를 남길 수 없어요.';
        }
        if (this.minihompy.guestbookWritePolicy === 'ILCHON') {
            return '이 방명록은 일촌에게만 열려 있어요.';
        }
        if (this.minihompy.guestbookWritePolicy === 'OWNER') {
            return '주인이 잠시 방명록 문을 닫아두었어요.';
        }
        return '로그인하면 방명록에 작은 인사를 남길 수 있어요.';
    }

    public get settingRows(): { label: string; value: string }[] {
        return [
            { label: '미니홈피 주소', value: this.minihompyUrl },
            { label: '미니룸 배경', value: this.miniroomBackgroundLabel(this.selectedMiniroomBackground) },
            { label: '미니룸 표시 방식', value: this.selectedMiniroomBackgroundFit },
            { label: '기본 다이어리 공개', value: this.formatVisibility(this.minihompy.defaultDiaryVisibility) },
            { label: '기본 사진 공개', value: this.formatVisibility(this.minihompy.defaultPhotoVisibility) },
            { label: '방명록 작성 권한', value: this.formatGuestbookPolicy(this.minihompy.guestbookWritePolicy) },
            { label: 'BGM 표시', value: this.minihompy.bgmEnabled ? '켜짐' : '꺼짐' }
        ];
    }

    public get canUseThemeSwitcher(): boolean {
        return Boolean(this.access.canUseThemeSwitcher || this.access.isAdmin);
    }

    public get settingThemes(): ThemeMeta[] {
        if (this.access.canUseAllThemes || this.access.isAdmin) {
            return this.themes;
        }
        return this.ownedThemes;
    }

    public get settingThemeCountLabel(): string {
        const count = this.settingThemes.length;
        if (this.access.canUseAllThemes || this.access.isAdmin) {
            return `${count}개 전체 테마`;
        }
        return count ? `${count}개 보유 테마` : '보유 테마 없음';
    }

    public get settingMiniroomBackgrounds(): MiniroomBackground[] {
        if (this.access.canUseAllMiniroomBackgrounds || this.access.isAdmin) {
            return this.miniroomBackgrounds;
        }
        return this.ownedMiniroomBackgrounds;
    }

    public get settingMiniroomBackgroundCountLabel(): string {
        const count = this.settingMiniroomBackgrounds.length;
        if (this.access.canUseAllMiniroomBackgrounds || this.access.isAdmin) {
            return `${count}개 전체 배경`;
        }
        return count ? `${count}개 보유 배경` : '보유 배경 없음';
    }

    public get canUseIlchonActions(): boolean {
        return Boolean(this.relationship.viewerUserId && !this.access.isOwner);
    }

    public get hasIlchonRows(): boolean {
        return Boolean(
            this.ilchon.incoming.length ||
            this.ilchon.outgoing.length ||
            this.ilchon.accepted.length ||
            this.ilchon.blocked.length
        );
    }

    public relationshipLabel(status: RelationshipStatus | string): string {
        const labels: { [key: string]: string } = {
            NONE: '아직 일촌 아님',
            PENDING_SENT: '신청장을 보냄',
            PENDING_RECEIVED: '신청장이 도착함',
            ACCEPTED: '일촌',
            BLOCKED: '차단됨'
        };
        return labels[String(status || 'NONE')] || '아직 일촌 아님';
    }

    public relationshipHint(status: RelationshipStatus | string): string {
        const hints: { [key: string]: string } = {
            NONE: '일촌 공개 다이어리는 서로 인사를 나눈 뒤 열립니다.',
            PENDING_SENT: '상대가 수락하면 일촌 공개 기록장이 열립니다.',
            PENDING_RECEIVED: '신청을 수락하면 서로의 일촌 공개 기록을 볼 수 있습니다.',
            ACCEPTED: '일촌 공개 기록장과 사진첩을 함께 볼 수 있습니다.',
            BLOCKED: '지금은 일촌 신청과 방명록 교류가 멈춰 있습니다.'
        };
        return hints[String(status || 'NONE')] || hints.NONE;
    }

    public async loadMinihompy(): Promise<void> {
        this.isLoading = true;
        this.loadError = '';
        try {
            const res = await wiz.call('load', { slug: this.slug });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '미니홈피 문을 열지 못했습니다.');
            }
            this.applyPayload(res.data || {});
        } catch (error) {
            this.loadError = this.friendlyError(error, '미니홈피 문을 열지 못했어요. 잠시 후 다시 찾아와 주세요.');
        }
        this.isLoading = false;
        await this.service.render();
    }

    public async setTab(tab: MinihompyTab): Promise<void> {
        this.isShopOpen = false;
        if (this.activeTab !== tab) {
            this.activeTab = tab;
        }
        this.service.href(this.tabPath(tab));
        await this.service.render();
    }

    public goToAccess(view: 'login' | 'signup' = 'login'): void {
        location.href = `/access?view=${view}`;
    }

    private canEnterDashboard(): boolean {
        try {
            if (this.service.auth.check()) return true;
        } catch (error) {
            // Fall through to the MVP auth gate.
        }
        return this.hasDevOwnerPreviewCookie();
    }

    private hasDevOwnerPreviewCookie(): boolean {
        const devValue = this.readCookie('season-wiz-devmode');
        return ['1', 'true', 'yes', 'y', 'on'].includes(devValue.toLowerCase());
    }

    private readCookie(name: string): string {
        const target = `${name}=`;
        const cookies = (document.cookie || '').split(';');
        for (const cookie of cookies) {
            const value = cookie.trim();
            if (value.startsWith(target)) return decodeURIComponent(value.slice(target.length));
        }
        return '';
    }

    private redirectToAccess(view: 'login' | 'signup' = 'login'): void {
        if (this.authGateRedirecting) return;
        this.authGateRedirecting = true;
        location.replace(`/access?view=${view}`);
    }

    public async openShop(): Promise<void> {
        this.isShopOpen = true;
        await this.loadShopCatalog();
    }

    public async closeShop(): Promise<void> {
        this.isShopOpen = false;
        await this.service.render();
    }

    public async loadShopCatalog(): Promise<void> {
        this.isLoadingShop = true;
        this.shopMessage = '';
        try {
            const res = await wiz.call('shop_catalog', { slug: this.slug });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '선물가게 catalog를 불러오지 못했습니다.');
            }
            this.applyShopCatalog(res.data || {});
            if (!this.shopItems.length) {
                this.shopMessage = '지금은 보여줄 선물이 없습니다.';
            }
        } catch (error) {
            this.shopMessage = this.friendlyError(error, '선물가게 문을 열지 못했어요. 잠시 후 다시 들러주세요.', 'shop');
        }
        this.isLoadingShop = false;
        await this.service.render();
    }

    public async purchaseShopItem(item: ShopItem): Promise<void> {
        if (!item || !item.purchaseReady || this.isPurchasingShopItem) {
            return;
        }
        this.isPurchasingShopItem = true;
        this.purchasingShopItemId = item.id;
        this.shopMessage = '';
        try {
            const res = await wiz.call('shop_purchase', { slug: this.slug, itemId: item.id });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '구매를 완료하지 못했습니다.');
            }
            const payload = res.data || {};
            this.applyPayload(payload);
            this.applyShopCatalog(payload.shopCatalog || payload);
            this.shopMessage = '구매가 완료되었습니다.';
        } catch (error) {
            this.shopMessage = this.friendlyError(error, '구매를 완료하지 못했습니다.', 'shop');
        }
        this.isPurchasingShopItem = false;
        this.purchasingShopItemId = '';
        await this.service.render();
    }

    public async setTheme(theme: MinihompyThemeId): Promise<void> {
        if (!this.canUseTheme(theme)) {
            this.settingsMessage = '보유한 테마만 적용할 수 있습니다.';
            await this.service.render();
            return;
        }
        this.activeTheme = theme;
        this.settingsForm.themeId = theme;
        window.localStorage.setItem('recollections-theme', theme);
        if (!this.isLoading && this.access.canEditProfile) {
            await this.saveSettings(true, '방 분위기를 새로 걸어두었습니다.');
            return;
        }
        await this.service.render();
    }

    public async setMiniroomBackground(backgroundId: string): Promise<void> {
        if (!this.isLoading && !this.access.canEditProfile) return;
        if (!this.canUseMiniroomBackground(backgroundId || '')) {
            this.miniroomBackgroundMessage = '보유한 미니룸 배경만 적용할 수 있습니다.';
            await this.service.render();
            return;
        }
        const safeId = this.resolveMiniroomBackgroundId(backgroundId || '', this.miniroomBackgrounds, true);
        this.settingsForm.selectedMiniroomBackgroundId = safeId;
        this.minihompy.selectedMiniroomBackgroundId = safeId;
        window.localStorage.setItem(this.miniroomBackgroundStorageKey(), safeId);

        if (!this.isLoading && this.access.canEditProfile) {
            this.isSavingMiniroomBackground = true;
            this.miniroomBackgroundMessage = '';
            try {
                const res = await wiz.call('select_miniroom_background', { slug: this.slug, id: safeId });
                if (res.code && res.code !== 200) {
                    throw new Error(res.data?.message || '미니룸 배경을 저장하지 못했습니다.');
                }
                this.applyPayload(res.data || {});
                this.miniroomBackgroundMessage = safeId ? '오늘의 미니룸 배경으로 남겨두었습니다.' : '미니룸을 기본 프레임으로 비워두었습니다.';
            } catch (error) {
                this.miniroomBackgroundMessage = error instanceof Error ? error.message : String(error);
            }
            this.isSavingMiniroomBackground = false;
            await this.service.render();
        }
    }

    public async setMiniroomBackgroundFit(value: string): Promise<void> {
        if (!this.isLoading && !this.access.canEditProfile) return;
        const fit = this.normalizeMiniroomBackgroundFit(value);
        this.settingsForm.miniroomBackgroundFit = fit;
        this.minihompy.miniroomBackgroundFit = fit;
        window.localStorage.setItem(this.miniroomBackgroundFitStorageKey(), fit);

        if (!this.isLoading && this.access.canEditProfile) {
            await this.saveSettings(true, '미니룸 표시 방식을 정리해두었습니다.');
            return;
        }

        this.settingsMessage = '미니룸 표시 방식을 적용했습니다.';
        await this.service.render();
    }

    public editMiniroomBackground(background: MiniroomBackground): void {
        this.miniroomBackgroundForm = {
            id: background.id,
            title: background.title || '',
            assetPath: background.assetPath || '',
            description: background.description || '',
            originalFilename: background.originalFilename || this.fileNameFromUrl(background.assetPath),
            mimeType: background.mimeType || this.miniroomMimeType(background.assetPath),
            width: Number(background.width || 0),
            height: Number(background.height || 0)
        };
        this.miniroomBackgroundMessage = '';
    }

    public startNewMiniroomBackground(): void {
        this.miniroomBackgroundForm = this.createEmptyMiniroomBackgroundForm();
        this.miniroomUploadFile = null;
        this.miniroomUploadProgress = 0;
        this.miniroomBackgroundMessage = '';
    }

    public onMiniroomUploadFileChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = input && input.files && input.files.length ? input.files[0] : null;
        this.miniroomUploadFile = file;
        this.miniroomUploadProgress = 0;
        this.miniroomBackgroundMessage = '';
        if (!file) return;

        if (!this.miniroomBackgroundForm.title) {
            this.miniroomBackgroundForm.title = this.titleFromFileName(file.name);
        }
        this.miniroomBackgroundForm.originalFilename = file.name;
        this.miniroomBackgroundForm.mimeType = file.type || this.miniroomMimeType(file.name);
    }

    public async uploadMiniroomBackground(): Promise<void> {
        if (!this.access.canEditProfile || this.isSavingMiniroomBackground) return;
        if (!this.miniroomUploadFile) {
            this.miniroomBackgroundMessage = '등록할 이미지/GIF 파일을 선택해 주세요.';
            await this.service.render();
            return;
        }
        if (this.miniroomUploadFile.size <= 0) {
            this.miniroomBackgroundMessage = '빈 파일은 등록할 수 없습니다.';
            await this.service.render();
            return;
        }
        if (this.miniroomUploadFile.size > this.miniroomUploadMaxBytes) {
            this.miniroomBackgroundMessage = '미니룸 배경 파일은 5MB 이하만 등록할 수 있습니다.';
            await this.service.render();
            return;
        }

        this.isSavingMiniroomBackground = true;
        this.miniroomBackgroundMessage = '';
        this.miniroomUploadProgress = 0;
        try {
            const formData = new FormData();
            const mimeType = this.miniroomUploadFile.type || this.miniroomMimeType(this.miniroomUploadFile.name);
            formData.append('slug', this.slug);
            formData.append('file', this.miniroomUploadFile, this.miniroomUploadFile.name);
            formData.append('data', JSON.stringify({
                title: String(this.miniroomBackgroundForm.title || this.titleFromFileName(this.miniroomUploadFile.name)).trim(),
                description: String(this.miniroomBackgroundForm.description || '').trim(),
                originalFilename: this.miniroomUploadFile.name,
                mimeType,
                selectNow: true
            }));
            const res = await this.service.file.upload('/wiz/api/page.dashboard/upload_miniroom_background', formData, (percent: number) => {
                this.miniroomUploadProgress = Math.round(Number(percent || 0));
                this.service.render();
            });
            if (res && res.code && res.code !== 200) {
                throw new Error(res.data?.message || '미니룸 배경 파일을 등록하지 못했습니다.');
            }
            const payload = res && res.data ? res.data : (res || {});
            this.applyPayload(payload || {});
            const selected = this.selectedMiniroomBackground;
            if (selected) this.editMiniroomBackground(selected);
            this.miniroomUploadFile = null;
            this.miniroomUploadProgress = 100;
            this.miniroomBackgroundMessage = '원본 파일을 건드리지 않고 미니룸에 걸어두었습니다.';
        } catch (error) {
            this.miniroomBackgroundMessage = error instanceof Error ? error.message : String(error);
        }
        this.isSavingMiniroomBackground = false;
        await this.service.render();
    }

    public async saveMiniroomBackground(): Promise<void> {
        if (!this.access.canEditProfile || this.isSavingMiniroomBackground) return;
        this.isSavingMiniroomBackground = true;
        this.miniroomBackgroundMessage = '';
        try {
            const wasEditing = Boolean(this.miniroomBackgroundForm.id);
            const payload = this.buildMiniroomBackgroundPayload();
            const params: any = { slug: this.slug, data: JSON.stringify(payload) };
            const apiName = wasEditing ? 'update_miniroom_background' : 'create_miniroom_background';
            if (wasEditing) {
                params.id = this.miniroomBackgroundForm.id;
            }
            const res = await wiz.call(apiName, params);
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '미니룸 배경을 저장하지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            const saved = this.findMiniroomBackgroundByTitle(payload.title) || this.selectedMiniroomBackground;
            if (saved) this.editMiniroomBackground(saved);
            this.miniroomBackgroundMessage = wasEditing ? '미니룸 배경 메모를 정리했습니다.' : '새 미니룸 배경을 방에 넣어두었습니다.';
        } catch (error) {
            this.miniroomBackgroundMessage = error instanceof Error ? error.message : String(error);
        }
        this.isSavingMiniroomBackground = false;
        await this.service.render();
    }

    public async deleteMiniroomBackground(): Promise<void> {
        if (!this.access.canEditProfile || this.isSavingMiniroomBackground || !this.miniroomBackgroundForm.id) return;
        const confirmed = window.confirm('선택한 미니룸 배경을 목록에서 잠시 치워둘까요?');
        if (!confirmed) return;
        this.isSavingMiniroomBackground = true;
        this.miniroomBackgroundMessage = '';
        try {
            const res = await wiz.call('delete_miniroom_background', { slug: this.slug, id: this.miniroomBackgroundForm.id });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '미니룸 배경을 비활성화하지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            this.startNewMiniroomBackground();
            this.miniroomBackgroundMessage = '미니룸 배경을 목록에서 치워두었습니다.';
        } catch (error) {
            this.miniroomBackgroundMessage = error instanceof Error ? error.message : String(error);
        }
        this.isSavingMiniroomBackground = false;
        await this.service.render();
    }

    public async saveSettings(silent: boolean = false, successMessage: string = '방 설정을 저장해두었습니다.'): Promise<void> {
        if (!this.access.canEditProfile) return;
        this.isSavingSettings = true;
        if (!silent) this.settingsMessage = '';
        try {
            const payload = this.buildSettingsPayload();
            const res = await wiz.call('save_settings', { slug: this.slug, data: JSON.stringify(payload) });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '설정을 저장하지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            this.settingsMessage = successMessage;
        } catch (error) {
            this.settingsMessage = this.friendlyError(error, '지금은 방 설정을 저장하지 못했어요. 잠시 후 다시 시도해 주세요.', 'settings');
        }
        this.isSavingSettings = false;
        await this.service.render();
    }

    public async requestIlchon(): Promise<void> {
        await this.runRelationshipAction('request_ilchon');
    }

    public async acceptIlchon(targetUserId?: string): Promise<void> {
        await this.runRelationshipAction('accept_ilchon', targetUserId || this.relationship.targetUserId);
    }

    public async deleteIlchon(targetUserId?: string): Promise<void> {
        const target = targetUserId || this.relationship.targetUserId;
        if (!target) return;
        const confirmed = window.confirm('일촌 관계를 정리할까요?');
        if (!confirmed) return;
        await this.runRelationshipAction('delete_ilchon', target);
    }

    public async blockUser(targetUserId?: string): Promise<void> {
        const target = targetUserId || this.relationship.targetUserId;
        if (!target) return;
        const confirmed = window.confirm('이 사용자를 차단할까요?');
        if (!confirmed) return;
        await this.runRelationshipAction('block_user', target);
    }

    public async runRelationshipAction(apiName: string, targetUserId?: string): Promise<void> {
        if (this.isSavingRelationship) return;
        this.isSavingRelationship = true;
        this.relationshipMessage = '';
        try {
            const params: any = { slug: this.slug };
            if (targetUserId) params.targetUserId = targetUserId;
            const res = await wiz.call(apiName, params);
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '일촌 상태를 변경하지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            this.relationshipMessage = '일촌 상태를 방명록에 정리했습니다.';
        } catch (error) {
            this.relationshipMessage = this.friendlyError(error, '지금은 일촌 상태를 정리하지 못했어요. 잠시 후 다시 시도해 주세요.', 'relationship');
        }
        this.isSavingRelationship = false;
        await this.service.render();
    }

    public async toggleBgm(): Promise<void> {
        if (!this.minihompy.bgmEnabled) return;
        if (this.isBgmPlaying) {
            this.stopBgmPlayback();
            this.bgmStatusMessage = '정지됨';
            await this.service.render();
            return;
        }
        try {
            await this.startBgmPlayback();
            this.bgmStatusMessage = '재생 중';
        } catch (error) {
            this.isBgmPlaying = false;
            this.bgmStatusMessage = error instanceof Error ? error.message : 'BGM을 재생하지 못했습니다.';
        }
        await this.service.render();
    }

    public async setVolume(event: Event): Promise<void> {
        const input = event.target as HTMLInputElement | null;
        if (!input) return;
        this.bgmVolume = Math.max(0, Math.min(100, Number(input.value) || 0));
        this.updateBgmGain();
        await this.service.render();
    }

    private async startBgmPlayback(): Promise<void> {
        const AudioContextClass = (window.AudioContext || (window as any).webkitAudioContext) as typeof AudioContext | undefined;
        if (!AudioContextClass) {
            throw new Error('이 브라우저는 BGM 재생을 지원하지 않습니다.');
        }
        if (!this.bgmAudioContext) {
            this.bgmAudioContext = new AudioContextClass();
        }
        if (this.bgmAudioContext.state === 'suspended') {
            await this.bgmAudioContext.resume();
        }

        this.stopBgmPlayback();
        this.bgmGain = this.bgmAudioContext.createGain();
        this.bgmGain.connect(this.bgmAudioContext.destination);
        this.updateBgmGain();

        const oscillator = this.bgmAudioContext.createOscillator();
        oscillator.type = 'sine';
        oscillator.frequency.value = this.bgmNotePattern[0];
        oscillator.connect(this.bgmGain);
        oscillator.start();
        this.bgmOscillator = oscillator;
        this.isBgmPlaying = true;
        this.bgmNoteIndex = 0;
        this.bgmPulseTimer = window.setInterval(() => {
            if (!this.bgmAudioContext || !this.bgmOscillator) return;
            this.bgmNoteIndex = (this.bgmNoteIndex + 1) % this.bgmNotePattern.length;
            this.bgmOscillator.frequency.setTargetAtTime(
                this.bgmNotePattern[this.bgmNoteIndex],
                this.bgmAudioContext.currentTime,
                0.04
            );
        }, 520);
    }

    private stopBgmPlayback(closeContext: boolean = false): void {
        if (this.bgmPulseTimer) {
            window.clearInterval(this.bgmPulseTimer);
            this.bgmPulseTimer = null;
        }
        if (this.bgmOscillator) {
            try {
                this.bgmOscillator.stop();
            } catch (error) {
                // Oscillator stop can throw if the node has already ended.
            }
            this.bgmOscillator.disconnect();
            this.bgmOscillator = null;
        }
        if (this.bgmGain) {
            this.bgmGain.disconnect();
            this.bgmGain = null;
        }
        if (closeContext && this.bgmAudioContext) {
            this.bgmAudioContext.close();
            this.bgmAudioContext = null;
        }
        this.isBgmPlaying = false;
    }

    private updateBgmGain(): void {
        if (!this.bgmGain || !this.bgmAudioContext) return;
        const gainValue = (Math.max(0, Math.min(100, Number(this.bgmVolume) || 0)) / 100) * 0.18;
        this.bgmGain.gain.setTargetAtTime(gainValue, this.bgmAudioContext.currentTime, 0.02);
    }

    public async startNewDiary(): Promise<void> {
        this.diaryEditing = false;
        this.diaryForm = this.createEmptyDiaryForm();
        this.diaryMessage = '';
        this.diaryDetailMessage = '';
        await this.service.render();
    }

    public async editDiary(entry: DiaryEntry): Promise<void> {
        if (!this.access.canCreateDiary) return;
        this.diaryEditing = true;
        this.selectedDiary = entry;
        this.diaryForm = {
            id: entry.id,
            title: entry.title,
            body: entry.body,
            entryDate: entry.entryDate,
            mood: entry.mood,
            visibility: entry.visibility
        };
        this.activeTab = 'Diary';
        await this.service.render();
    }

    public async setDiaryMonth(month: string): Promise<void> {
        this.selectedDiaryMonth = month;
        this.selectedDiary = this.filteredDiaryEntries[0] || null;
        this.diaryDetailMessage = '';
        await this.service.render();
    }

    public async viewDiary(entry: DiaryEntry): Promise<void> {
        this.diaryDetailMessage = '';
        try {
            const res = await wiz.call('get_diary', { slug: this.slug, id: entry.id });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '다이어리를 불러오지 못했습니다.');
            }
            this.selectedDiary = (res.data && res.data.diaryEntry) ? res.data.diaryEntry : entry;
        } catch (error) {
            this.selectedDiary = null;
            this.diaryDetailMessage = this.friendlyError(error, '이 기록은 아직 열려 있지 않아요.', 'diary');
        }
        await this.service.render();
    }

    public async cancelDiary(): Promise<void> {
        this.diaryEditing = false;
        this.diaryForm = this.createEmptyDiaryForm();
        this.diaryMessage = '';
        await this.service.render();
    }

    public async saveDiary(): Promise<void> {
        if (!this.access.canCreateDiary) return;
        this.isSavingDiary = true;
        this.diaryMessage = '';
        const wasEditing = this.diaryEditing;
        try {
            const payload = {
                title: this.diaryForm.title,
                body: this.diaryForm.body,
                entryDate: this.diaryForm.entryDate,
                mood: this.diaryForm.mood,
                visibility: this.diaryForm.visibility
            };
            const apiName = this.diaryEditing ? 'update_diary' : 'create_diary';
            const params: any = { slug: this.slug, data: JSON.stringify(payload) };
            if (this.diaryEditing) params.id = this.diaryForm.id;
            const res = await wiz.call(apiName, params);
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '다이어리를 저장하지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            this.diaryEditing = false;
            this.diaryForm = this.createEmptyDiaryForm();
            this.selectedDiary = this.filteredDiaryEntries[0] || this.selectedDiary;
            this.diaryMessage = wasEditing ? '다이어리 한 장을 다시 접어두었습니다.' : '오늘의 작은 기록을 남겨두었습니다.';
        } catch (error) {
            this.diaryMessage = this.friendlyError(error, '지금은 저장하지 못했어요. 잠시 후 다시 시도해 주세요.', 'diary');
        }
        this.isSavingDiary = false;
        await this.service.render();
    }

    public async deleteDiary(entry: DiaryEntry): Promise<void> {
        if (!this.access.canCreateDiary) return;
        const confirmed = window.confirm('이 다이어리 한 장을 지울까요? 지우면 다시 펼칠 수 없어요.');
        if (!confirmed) return;
        this.isSavingDiary = true;
        this.diaryMessage = '';
        try {
            const res = await wiz.call('delete_diary', { slug: this.slug, id: entry.id });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '다이어리를 삭제하지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            this.selectedDiary = this.filteredDiaryEntries[0] || null;
            this.diaryMessage = '다이어리 한 장을 조용히 지웠습니다.';
        } catch (error) {
            this.diaryMessage = this.friendlyError(error, '지금은 삭제하지 못했어요. 잠시 후 다시 시도해 주세요.', 'diary');
        }
        this.isSavingDiary = false;
        await this.service.render();
    }

    public async setPhotoAlbum(album: PhotoAlbum): Promise<void> {
        this.selectedPhotoAlbumId = album.id;
        this.selectedPhoto = this.selectedAlbumPhotos[0] || null;
        this.photoDetailMessage = '';
        if (!this.photoEditing) {
            this.photoForm = this.createEmptyPhotoForm();
        }
        await this.service.render();
    }

    public async startNewPhotoAlbum(): Promise<void> {
        this.photoAlbumEditing = false;
        this.photoAlbumForm = this.createEmptyPhotoAlbumForm();
        this.photoMessage = '';
        await this.service.render();
    }

    public async editPhotoAlbum(album: PhotoAlbum): Promise<void> {
        if (!this.canManagePhotos) return;
        this.photoAlbumEditing = true;
        this.photoAlbumForm = {
            id: album.id,
            name: album.name,
            note: album.note,
            visibility: album.visibility
        };
        await this.setPhotoAlbum(album);
    }

    public async savePhotoAlbum(): Promise<void> {
        if (!this.canManagePhotos) return;
        this.isSavingPhoto = true;
        this.photoMessage = '';
        try {
            const payload = {
                name: this.photoAlbumForm.name,
                note: this.photoAlbumForm.note,
                visibility: this.photoAlbumForm.visibility
            };
            const apiName = this.photoAlbumEditing ? 'update_photo_album' : 'create_photo_album';
            const params: any = { slug: this.slug, data: JSON.stringify(payload) };
            if (this.photoAlbumEditing) params.id = this.photoAlbumForm.id;
            const res = await wiz.call(apiName, params);
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '앨범을 저장하지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            this.photoAlbumEditing = false;
            this.photoAlbumForm = this.createEmptyPhotoAlbumForm();
            this.photoMessage = '앨범 한 칸을 사진첩에 남겨두었습니다.';
        } catch (error) {
            this.photoMessage = this.friendlyError(error, '지금은 앨범을 저장하지 못했어요. 잠시 후 다시 시도해 주세요.', 'photo');
        }
        this.isSavingPhoto = false;
        await this.service.render();
    }

    public async startNewPhoto(): Promise<void> {
        if (!this.canManagePhotos) return;
        this.photoEditing = false;
        this.photoForm = this.createEmptyPhotoForm();
        this.photoMessage = '';
        await this.service.render();
    }

    public async editPhoto(photo: PhotoItem): Promise<void> {
        if (!this.canManagePhotos) return;
        this.photoEditing = true;
        this.selectedPhoto = photo;
        this.selectedPhotoAlbumId = photo.albumId;
        this.photoForm = {
            id: photo.id,
            albumId: photo.albumId,
            title: photo.title,
            caption: photo.caption,
            takenAt: photo.takenAt,
            sourceUrl: photo.imageUrl || '',
            fileName: photo.fileName || '',
            mimeType: photo.mimeType || 'image/jpeg',
            fileSize: Number(photo.fileSize || 0),
            visibility: photo.visibility || 'INHERIT'
        };
        this.photoMessage = '';
        await this.service.render();
    }

    public async cancelPhoto(): Promise<void> {
        this.photoEditing = false;
        this.photoForm = this.createEmptyPhotoForm();
        this.photoMessage = '';
        await this.service.render();
    }

    public async savePhoto(): Promise<void> {
        if (!this.canManagePhotos || !this.photoForm.albumId) return;
        this.isSavingPhoto = true;
        this.photoMessage = '';
        try {
            const payload: any = {
                albumId: this.photoForm.albumId,
                title: this.photoForm.title,
                caption: this.photoForm.caption,
                takenAt: this.photoForm.takenAt,
                fileName: this.photoForm.fileName,
                mimeType: this.photoForm.mimeType,
                fileSize: this.photoForm.fileSize,
                visibility: this.photoForm.visibility
            };
            if (!this.photoEditing || this.photoForm.sourceUrl) {
                payload.sourceUrl = this.photoForm.sourceUrl;
            }
            const apiName = this.photoEditing ? 'update_photo' : 'create_photo';
            const params: any = { slug: this.slug, data: JSON.stringify(payload) };
            if (this.photoEditing) params.id = this.photoForm.id;
            const res = await wiz.call(apiName, params);
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '사진을 저장하지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            this.photoEditing = false;
            this.photoForm = this.createEmptyPhotoForm();
            this.selectedPhoto = this.selectedAlbumPhotos[0] || this.selectedPhoto;
            this.photoMessage = '사진첩에 작은 기억을 보관했습니다.';
        } catch (error) {
            this.photoMessage = this.friendlyError(error, '지금은 사진을 저장하지 못했어요. 잠시 후 다시 시도해 주세요.', 'photo');
        }
        this.isSavingPhoto = false;
        await this.service.render();
    }

    public async viewPhoto(photo: PhotoItem): Promise<void> {
        this.photoDetailMessage = '';
        try {
            const res = await wiz.call('get_photo', { slug: this.slug, id: photo.id });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '사진을 불러오지 못했습니다.');
            }
            this.selectedPhoto = (res.data && res.data.photo) ? res.data.photo : photo;
        } catch (error) {
            this.selectedPhoto = null;
            this.photoDetailMessage = this.friendlyError(error, '사진을 불러오지 못했어요.', 'photo');
        }
        await this.service.render();
    }

    public async deletePhoto(photo: PhotoItem): Promise<void> {
        if (!this.canManagePhotos) return;
        const confirmed = window.confirm('이 사진을 사진첩에서 지울까요? 지우면 다시 보이지 않아요.');
        if (!confirmed) return;
        this.isSavingPhoto = true;
        this.photoMessage = '';
        try {
            const res = await wiz.call('delete_photo', { slug: this.slug, id: photo.id });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '사진을 삭제하지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            this.selectedPhoto = this.selectedAlbumPhotos[0] || null;
            this.photoMessage = '사진첩에서 사진을 조용히 지웠습니다.';
        } catch (error) {
            this.photoMessage = this.friendlyError(error, '지금은 사진을 삭제하지 못했어요. 잠시 후 다시 시도해 주세요.', 'photo');
        }
        this.isSavingPhoto = false;
        await this.service.render();
    }

    public async saveGuestbook(): Promise<void> {
        if (!this.access.canWriteGuestbook || this.isSavingGuestbook) return;
        this.isSavingGuestbook = true;
        this.guestbookMessage = '';
        try {
            const payload = { message: this.guestbookForm.message };
            const res = await wiz.call('create_guestbook', { slug: this.slug, data: JSON.stringify(payload) });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '방명록을 저장하지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            this.guestbookForm = this.createEmptyGuestbookForm();
            this.guestbookMessage = '작은 인사가 방명록에 남았습니다.';
        } catch (error) {
            this.guestbookMessage = this.friendlyError(error, '잠시 후 다시 남겨주세요.', 'guestbook');
        }
        this.isSavingGuestbook = false;
        await this.service.render();
    }

    public async hideGuestbook(entry: GuestbookEntry): Promise<void> {
        if (!entry.id || !entry.canHide || this.isSavingGuestbook) return;
        this.isSavingGuestbook = true;
        this.guestbookMessage = '';
        try {
            const res = await wiz.call('hide_guestbook', {
                slug: this.slug,
                id: entry.id,
                hidden: entry.isHidden ? 'false' : 'true'
            });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '방명록 표시 상태를 바꾸지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            this.guestbookMessage = entry.isHidden ? '방명록 쪽지를 다시 열어두었습니다.' : '방명록 쪽지를 살짝 숨겼습니다.';
        } catch (error) {
            this.guestbookMessage = this.friendlyError(error, '지금은 방명록 표시를 바꾸지 못했어요. 잠시 후 다시 시도해 주세요.', 'guestbook');
        }
        this.isSavingGuestbook = false;
        await this.service.render();
    }

    public async deleteGuestbook(entry: GuestbookEntry): Promise<void> {
        if (!entry.id || !entry.canDelete || this.isSavingGuestbook) return;
        const confirmed = window.confirm('이 방명록 쪽지를 지울까요? 지우면 다시 보이지 않아요.');
        if (!confirmed) return;
        this.isSavingGuestbook = true;
        this.guestbookMessage = '';
        try {
            const res = await wiz.call('delete_guestbook', { slug: this.slug, id: entry.id });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '방명록을 삭제하지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            this.guestbookMessage = '방명록 쪽지를 지웠습니다.';
        } catch (error) {
            this.guestbookMessage = this.friendlyError(error, '지금은 방명록을 삭제하지 못했어요. 잠시 후 다시 시도해 주세요.', 'guestbook');
        }
        this.isSavingGuestbook = false;
        await this.service.render();
    }

    public async reportContent(targetType: ReportTargetType, targetId: string, label: string = ''): Promise<void> {
        if (!this.access.canReport || this.isReporting || !targetId) return;
        const reason = window.prompt(`${label || this.formatReportTargetType(targetType)}을 신고하는 이유를 짧게 남겨주세요.`, '');
        if (reason === null) return;
        this.isReporting = true;
        this.moderationMessage = '';
        this.guestbookMessage = '';
        this.diaryMessage = '';
        this.photoMessage = '';
        try {
            const payload = { targetType, targetId, reason };
            const res = await wiz.call('report_content', { slug: this.slug, data: JSON.stringify(payload) });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '신고를 접수하지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            this.moderationMessage = '신고 메모를 접수했습니다.';
        } catch (error) {
            this.moderationMessage = this.friendlyError(error, '지금은 신고를 접수하지 못했어요. 잠시 후 다시 시도해 주세요.', 'report');
        }
        this.isReporting = false;
        await this.service.render();
    }

    public async moderateReport(report: ModerationReport, status: ModerationStatus): Promise<void> {
        if (!this.access.canModerateReports || this.isSavingModeration || !report.id) return;
        this.isSavingModeration = true;
        this.moderationMessage = '';
        try {
            const res = await wiz.call('moderate_report', { slug: this.slug, id: report.id, status });
            if (res.code && res.code !== 200) {
                throw new Error(res.data?.message || '신고 상태를 변경하지 못했습니다.');
            }
            this.applyPayload(res.data || {});
            this.moderationMessage = '신고 항목 상태가 저장되었습니다.';
        } catch (error) {
            this.moderationMessage = error instanceof Error ? error.message : String(error);
        }
        this.isSavingModeration = false;
        await this.service.render();
    }

    public formatReportTargetType(value: ReportTargetType | string): string {
        const labels: { [key: string]: string } = {
            MINIHOMPY: '미니홈피',
            USER: '사용자',
            DIARY: '다이어리',
            PHOTO: '사진',
            GUESTBOOK: '방명록'
        };
        return labels[String(value || '')] || String(value || '');
    }

    public moderationStatusLabel(value: ModerationStatus | string): string {
        const match = this.moderationStatusOptions.find((item) => item.value === value);
        return match ? match.label : String(value || '');
    }

    public formatVisibility(value: Visibility | string): string {
        const match = this.visibilityOptions.find((item) => item.value === value);
        return match ? match.label : String(value || '');
    }

    public visibilityHelp(value: Visibility | string): string {
        const hints: { [key: string]: string } = {
            PUBLIC: '방문한 누구나 볼 수 있어요.',
            ILCHON: '수락한 일촌에게만 보여요.',
            PRIVATE: '주인만 볼 수 있는 기록이에요.'
        };
        return hints[String(value || '').toUpperCase()] || '';
    }

    public formatPhotoVisibility(value: PhotoVisibilityFormValue | string, effective?: Visibility): string {
        if (value === 'INHERIT') {
            return `앨범 기본 (${this.formatVisibility(effective || 'PUBLIC')})`;
        }
        return this.formatVisibility(value || effective || '');
    }

    public photoAccessLabel(photo: PhotoItem | null): string {
        if (!photo || !photo.fileAccess) return '사진 파일 없음';
        if (photo.fileAccess.mode === 'PUBLIC_URL') return '방문한 누구나 볼 수 있는 사진입니다.';
        if (photo.fileAccess.mode === 'SIGNED_URL') {
            if (photo.effectiveVisibility === 'PRIVATE') return '나만 간직하는 사진입니다.';
            return '일촌에게만 보이는 사진입니다.';
        }
        return '사진을 불러오지 못했어요.';
    }

    public photoSignedHint(photo: PhotoItem | null): string {
        if (!photo || !photo.fileAccess || photo.fileAccess.mode !== 'SIGNED_URL') return '';
        return photo.effectiveVisibility === 'PRIVATE' ? '주인만 잠깐 열어볼 수 있어요.' : '일촌 확인 후 잠깐 열리는 사진이에요.';
    }

    public photoPlaceholderLabel(photo: PhotoItem | null): string {
        if (!photo) return '사진을 불러오지 못했어요.';
        if (photo.fileAccess && photo.fileAccess.mode === 'PLACEHOLDER') return '사진을 불러오지 못했어요.';
        if (photo.effectiveVisibility === 'PRIVATE') return '나만 보기';
        if (photo.effectiveVisibility === 'ILCHON') return '일촌 공개';
        return '사진을 불러오지 못했어요.';
    }

    public photoTitleText(photo: PhotoItem | null): string {
        return this.fallbackText(photo?.title || '', '제목 없는 사진');
    }

    public photoCaptionText(photo: PhotoItem | null): string {
        return this.fallbackText(photo?.caption || '', '이 사진에는 아직 조용한 설명이 없습니다.');
    }

    public diaryBodyText(entry: DiaryEntry | null): string {
        return this.fallbackText(entry?.body || '', '오늘의 작은 기록을 기다리고 있어요.');
    }

    public onPhotoImageError(photo: PhotoItem | null): void {
        if (!photo) return;
        photo.imageUrl = '';
        if (this.selectedPhoto && this.selectedPhoto.id === photo.id) {
            this.selectedPhoto.imageUrl = '';
            this.photoDetailMessage = '사진을 불러오지 못했어요.';
        }
        this.service.render();
    }

    public miniroomBackgroundLabel(background: MiniroomBackground | null): string {
        if (!background) return '기본 프레임';
        return this.shortMiniroomTitle(background.title || background.originalFilename || background.assetPath);
    }

    public miniroomBackgroundMeta(background: MiniroomBackground): string {
        const type = (background.mimeType || '').replace('image/', '').toUpperCase();
        const size = background.width && background.height ? `${background.width}x${background.height}` : '';
        const animated = background.isAnimated ? '움직임' : '';
        return [type, size, animated].filter(Boolean).join(' · ');
    }

    public shopTypeLabel(type: ShopItemType | string): string {
        if (type === 'THEME') return '테마';
        if (type === 'MINIROOM_BACKGROUND') return '미니룸 배경';
        return String(type || '');
    }

    public shopPriceLabel(item: ShopItem): string {
        const price = Math.max(0, Number(item.price || 0));
        return price ? `${price} POINT` : '0 POINT';
    }

    public shopStatusLabel(item: ShopItem): string {
        if (item.admin || this.access.isAdmin) return '관리자용';
        if (item.current) return '적용중';
        if (item.owned) return '보유중';
        if (item.available) return '구매 가능';
        return '준비중';
    }

    public shopActionLabel(item: ShopItem): string {
        if (this.purchasingShopItemId && this.purchasingShopItemId === item.id) return '구매 중';
        if (item.actionLabel) return item.actionLabel;
        if (item.admin || this.access.isAdmin) return '관리자 확인';
        if (item.current) return '적용중';
        if (item.owned) return '보유중';
        if (item.purchaseReady) return '구매하기';
        return item.available ? '포인트 부족' : '준비중';
    }

    public canUseTheme(themeId: string): boolean {
        const normalized = String(themeId || '') as MinihompyThemeId;
        if (!this.isTheme(normalized)) return false;
        if (this.access.canUseAllThemes || this.canUseThemeSwitcher) return true;
        return this.ownedThemes.some((theme: ThemeMeta) => theme.id === normalized);
    }

    public canUseMiniroomBackground(backgroundId: string): boolean {
        const normalized = String(backgroundId || '').trim();
        if (!normalized) return true;
        if (this.access.canUseAllMiniroomBackgrounds || this.access.isAdmin) return true;
        return this.ownedMiniroomBackgrounds.some((background: MiniroomBackground) => background.id === normalized);
    }

    public miniroomUploadFileLabel(): string {
        if (!this.miniroomUploadFile) return '아직 고른 파일이 없습니다.';
        return `${this.miniroomUploadFile.name} / ${this.formatFileSize(this.miniroomUploadFile.size)}`;
    }

    public isMiniroomBackgroundSelected(background: MiniroomBackground): boolean {
        return this.settingsForm.selectedMiniroomBackgroundId === background.id;
    }

    public isMiniroomBackgroundFormBlank(): boolean {
        return !String(this.miniroomBackgroundForm.title || '').trim() || !String(this.miniroomBackgroundForm.assetPath || '').trim();
    }

    public isSelectedPhoto(photo: PhotoItem): boolean {
        const selected = this.selectedPhotoEntry;
        return Boolean(selected && selected.id === photo.id);
    }

    public formatGuestbookPolicy(value: GuestbookPolicy | string): string {
        const match = this.guestbookPolicyOptions.find((item) => item.value === value);
        return match ? match.label : String(value || '');
    }

    public guestbookStatusLabel(entry: GuestbookEntry): string {
        return entry.isHidden ? '숨김' : '공개';
    }

    public isGuestbookFormBlank(): boolean {
        return !String(this.guestbookForm.message || '').trim();
    }

    public formatDiaryMonth(value: string): string {
        const parts = String(value || '').split('-');
        if (parts.length < 2) return '월별 기록';
        return `${parts[0]}년 ${parts[1]}월`;
    }

    public isSelectedDiary(entry: DiaryEntry): boolean {
        const selected = this.selectedDiaryEntry;
        return Boolean(selected && selected.id === entry.id);
    }

    public diaryExcerpt(entry: DiaryEntry): string {
        const body = (entry.body || '').replace(/\s+/g, ' ').trim();
        if (body.length <= 72) return body;
        return `${body.slice(0, 72)}...`;
    }

    public moodLabel(value: string): string {
        const labels: { [key: string]: string } = {
            quiet: '조용한 날',
            focus: '정리 중',
            note: '메모',
            calm: '차분함'
        };
        return labels[String(value || '').toLowerCase()] || (value ? value : '메모');
    }

    private friendlyError(error: any, fallback: string, context: string = ''): string {
        const raw = error instanceof Error ? error.message : String(error || '');
        const message = raw.trim();
        if (!message) return fallback;

        if (message.indexOf('Rate limit exceeded: GUESTBOOK_WRITE') >= 0) return '잠시 후 다시 남겨주세요.';
        if (message.indexOf('Rate limit exceeded: ILCHON_REQUEST') >= 0) return '일촌 신청은 잠시 후 다시 보내주세요.';
        if (message === 'Login required') return '로그인하면 남길 수 있어요.';
        if (message === 'Blocked') return '지금은 서로의 공간에 인사를 남길 수 없어요.';
        if (message === 'Minihompy not found') return '이 작은 방은 아직 열려 있지 않아요.';
        if (message === 'Diary entry not found') return '이 기록은 아직 열려 있지 않아요.';
        if (message === 'Photo not found') return '이 사진은 아직 열려 있지 않아요.';
        if (message === 'Photo album not found') return '사진을 넣을 앨범을 찾지 못했어요.';
        if (message === 'Guestbook write not allowed') return this.guestbookAccessHint || '지금은 방명록을 남길 수 없어요.';
        if (message === 'Guestbook message required') return '방명록에 작은 인사를 한 줄 적어주세요.';
        if (message === 'Guestbook entry not found') return '이 방명록 쪽지는 더 이상 보이지 않아요.';
        if (message === 'Cannot report own content') return '내가 남긴 항목은 신고하지 않아도 괜찮아요.';
        if (message === 'Report already pending') return '이미 접수된 신고를 검토 중입니다.';
        if (message === 'Report target not found') return '신고할 항목을 찾지 못했어요.';
        if (context === 'shop' && (
            message.indexOf('포인트') >= 0 ||
            message.indexOf('아이템') >= 0 ||
            message.indexOf('상품') >= 0 ||
            message.indexOf('선물가게') >= 0 ||
            message.indexOf('미니홈피') >= 0
        )) return message;
        if (message === 'Photo file type not allowed' || message === 'Photo file type mismatch') return '사진 파일 형식을 다시 확인해 주세요.';
        if (message === 'Photo file size invalid') return '사진 파일 크기를 다시 확인해 주세요.';
        if (message === 'Photo file size exceeds limit') return '사진 파일은 5MB 이하만 올릴 수 있어요.';
        if (message.indexOf('PNG, JPG, JPEG, GIF') >= 0) return message;
        if (message === '등록할 이미지 파일을 선택해 주세요.') return message;
        if (message === '빈 파일은 등록할 수 없습니다.') return message;
        if (message === '이미지 파일은 5MB 이하만 등록할 수 있습니다.') return message;
        if (message === '파일 확장자와 실제 형식이 맞지 않습니다.') return message;
        if (message === '이 미니홈피의 주인만 파일을 등록할 수 있습니다.') return message;
        if (message === '파일을 저장하지 못했습니다. 잠시 후 다시 시도해 주세요.') return message;
        if (message === '파일 정보를 저장하지 못했습니다. 잠시 후 다시 시도해 주세요.') return message;
        if (message === '오늘은 이미지 파일을 많이 등록했습니다. 잠시 쉬었다가 다시 시도해 주세요.') return message;
        if (message === 'Not allowed') {
            const byContext: { [key: string]: string } = {
                diary: '주인만 정리할 수 있는 다이어리입니다.',
                photo: '주인만 정리할 수 있는 사진첩입니다.',
                guestbook: '주인만 정리할 수 있는 방명록입니다.',
                relationship: '지금은 일촌 상태를 바꿀 수 없어요.',
                report: '지금은 신고를 접수할 수 없어요.',
                settings: '주인만 방 설정을 바꿀 수 있어요.'
            };
            return byContext[context] || '주인만 정리할 수 있는 공간입니다.';
        }
        return fallback;
    }

    private fallbackText(value: string, fallback: string): string {
        const text = String(value || '').trim();
        return text || fallback;
    }

    private compactText(value: string, limit: number = 82): string {
        const text = this.fallbackText(value, '').replace(/\s+/g, ' ');
        if (text.length <= limit) return text;
        return `${text.slice(0, Math.max(0, limit - 3))}...`;
    }

    private homeDiaryReviewBody(entry: DiaryEntry): string {
        const body = String(entry.body || '');
        if (/좌측 프로필|중앙 콘텐츠|HTML\/CSS|API|PUBLIC|ILCHON|PRIVATE/.test(body)) {
            return '오늘 남긴 다이어리 한 장을 살짝 펼쳐두었습니다.';
        }
        return this.compactText(body || '오늘의 다이어리 한 장을 살짝 펼쳐두었습니다.', 82);
    }

    private homeDiaryReviewTitle(entry: DiaryEntry): string {
        const title = this.fallbackText(entry.title, '제목 없는 기록');
        if (/템플릿 셸|공개 범위 구조|테스트 항목/.test(title)) {
            return 'Diary - 작은 방 기록';
        }
        return `Diary - ${title}`;
    }

    private homeDiarySummaryTitle(entry: DiaryEntry): string {
        const title = this.fallbackText(entry.title, '제목 없는 기록');
        if (/템플릿 셸|공개 범위 구조|테스트 항목/.test(title)) {
            return '작은 방 기록을 정리하는 중';
        }
        return title;
    }

    private homePhotoReviewBody(photo: PhotoItem): string {
        const caption = String(photo.caption || '');
        if (/PUBLIC|ILCHON|PRIVATE|public URL|signed URL/i.test(caption)) {
            return '사진첩 한 칸에 조용히 보관한 사진입니다.';
        }
        return this.compactText(caption || '사진첩 한 칸에 조용히 보관한 사진입니다.', 82);
    }

    private reviewDisplayDate(value: string): string {
        const text = String(value || '').trim();
        const match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (match) return `${match[1]}.${match[2]}.${match[3]}`;
        return text || '오늘';
    }

    private reviewSortKey(value: string): string {
        return String(value || '').trim() || '0000-00-00';
    }

    private profileHistoryText(updatedAt: string): string {
        const date = this.reviewDisplayDate(updatedAt);
        if (date === '오늘') return '아직 남긴 기록이 없어요.';
        return `${date} - 작은 방을 다시 정리한 날`;
    }

    private profileMoodText(minihompy: MinihompyProfile): string {
        return minihompy.bgmEnabled ? '오늘의 BGM을 켜두는 중' : '오늘은 조용히 쉬는 중';
    }

    private profileBioText(value: string): string {
        const text = this.fallbackText(value, '작은 기억을 천천히 정리하는 중입니다.');
        if (text.includes('기능보다 먼저') || text.includes('레트로한 셸')) {
            return '느린 기록, 사진, 방명록을 천천히 모아두는 작은 웹 방입니다.';
        }
        return text;
    }

    private shortMiniroomTitle(value: string): string {
        const text = this.fallbackText(value, '기본 프레임');
        const match = text.match(/^Miniroom Background\s+(\d+)$/i);
        if (match) return `작은 방 배경 ${match[1]}`;
        return text;
    }

    private applyShopCatalog(data: any): void {
        const items = this.normalizeShopItems(data.shopItems || []);
        this.shopItems = items;
        this.shopThemeItems = items.filter((item: ShopItem) => item.type === 'THEME');
        this.shopMiniroomBackgroundItems = items.filter((item: ShopItem) => item.type === 'MINIROOM_BACKGROUND');
        this.shopPointBalanceLabel = String(data.pointBalanceLabel || 'POINT 잔액');
    }

    private normalizeShopItems(items: any[]): ShopItem[] {
        if (!Array.isArray(items) || !items.length) return [];
        const result: ShopItem[] = [];
        const seen: { [key: string]: boolean } = {};
        for (const raw of items) {
            const type = String(raw?.type || raw?.itemType || '').trim() as ShopItemType;
            if (type !== 'THEME' && type !== 'MINIROOM_BACKGROUND') continue;
            const id = String(raw?.id || '').trim();
            const itemId = String(raw?.itemId || raw?.item_id || '').trim();
            const key = `${type}:${id || itemId}`;
            if (!id || !itemId || seen[key]) continue;
            seen[key] = true;
            result.push({
                id,
                itemId,
                type,
                title: String(raw?.title || itemId),
                preview: String(raw?.preview || ''),
                price: Math.max(0, Number(raw?.price || raw?.pricePoints || 0)),
                owned: Boolean(raw?.owned),
                current: Boolean(raw?.current),
                available: Boolean(raw?.available),
                admin: Boolean(raw?.admin),
                status: String(raw?.status || ''),
                purchaseReady: Boolean(raw?.purchaseReady),
                actionLabel: String(raw?.actionLabel || ''),
                sortOrder: Number(raw?.sortOrder || raw?.sort_order || 0)
            });
        }
        return result.sort((a: ShopItem, b: ShopItem) => {
            const orderDiff = Number(a.sortOrder || 0) - Number(b.sortOrder || 0);
            if (orderDiff) return orderDiff;
            return a.id.localeCompare(b.id);
        });
    }

    private applyPayload(data: any): void {
        if (!data.minihompy) return;
        const minihompy = data.minihompy as MinihompyProfile;
        if (!this.isTheme(minihompy.themeId)) {
            minihompy.themeId = 'sky';
        }
        this.slug = minihompy.slug || this.slug;
        const backgrounds = this.resolveMiniroomBackgrounds(data.miniroomBackgrounds || [], minihompy.ownerId);
        minihompy.selectedMiniroomBackgroundId = this.resolveMiniroomBackgroundId(
            minihompy.selectedMiniroomBackgroundId,
            backgrounds,
            true,
            false
        );
        minihompy.miniroomBackgroundFit = this.resolveMiniroomBackgroundFit(minihompy.miniroomBackgroundFit);
        window.localStorage.setItem(this.miniroomBackgroundStorageKey(), minihompy.selectedMiniroomBackgroundId || '');
        window.localStorage.setItem(this.miniroomBackgroundFitStorageKey(), minihompy.miniroomBackgroundFit);
        this.minihompy = minihompy;
        this.activeTheme = minihompy.themeId;
        window.localStorage.setItem('recollections-theme', this.activeTheme);
        if (!minihompy.bgmEnabled && this.isBgmPlaying) {
            this.stopBgmPlayback();
            this.bgmStatusMessage = '오늘은 조용한 방';
        } else if (minihompy.bgmEnabled && !this.isBgmPlaying && this.bgmStatusMessage === '오늘은 조용한 방') {
            this.bgmStatusMessage = '클릭 후 재생 대기';
        }
        this.profile = {
            name: this.fallbackText(minihompy.nickname, '이름 없는 방 주인'),
            title: this.fallbackText(minihompy.title, 'Recollections'),
            status: this.fallbackText(minihompy.statusMessage, '오늘의 기분을 고르는 중'),
            history: this.profileHistoryText(minihompy.updatedAt || ''),
            mood: this.profileMoodText(minihompy),
            bio: this.profileBioText(minihompy.bio),
            profileImageUrl: minihompy.profileImageUrl
        };
        this.visit = {
            today: Number(minihompy.todayVisitCount || 0),
            total: Number(minihompy.totalVisitCount || 0)
        };
        this.viewer = data.viewer || this.viewer;
        this.access = this.normalizeAccess(data.access || this.access);
        this.relationship = data.relationship || this.createDefaultRelationship();
        this.ilchon = data.ilchon || this.createDefaultIlchonOverview();
        this.moderation = data.moderation || this.createDefaultModeration();
        this.moderationReports = this.moderation.reports || [];
        this.diaryEntries = data.diaryEntries || [];
        this.photoAlbums = data.photoAlbums || [];
        this.photos = data.photos || [];
        this.miniroomBackgrounds = backgrounds;
        this.ownedThemes = this.normalizeOwnedThemes(data.ownedThemes || []);
        this.ownedMiniroomBackgrounds = this.normalizeOwnedMiniroomBackgrounds(data.ownedMiniroomBackgrounds || [], backgrounds);
        this.visitors = data.guestbookEntries || [];
        this.syncDiarySelection();
        this.syncPhotoSelection();
        this.settingsForm = this.createSettingsForm(minihompy);
        if (!this.diaryEditing) {
            this.diaryForm = this.createEmptyDiaryForm();
        }
        if (!this.photoAlbumEditing) {
            this.photoAlbumForm = this.createEmptyPhotoAlbumForm();
        }
        if (!this.photoEditing) {
            this.photoForm = this.createEmptyPhotoForm();
        }
    }

    private normalizeAccess(access: Partial<AccessMatrix> | any): AccessMatrix {
        const normalized: AccessMatrix = {
            ...this.access,
            ...(access || {})
        };
        normalized.isAdmin = Boolean(normalized.isAdmin);
        normalized.canUseThemeSwitcher = Boolean(normalized.canUseThemeSwitcher || normalized.isAdmin);
        normalized.canUseAllThemes = Boolean(normalized.canUseAllThemes || normalized.isAdmin);
        normalized.canUseAllMiniroomBackgrounds = Boolean(normalized.canUseAllMiniroomBackgrounds || normalized.isAdmin);
        return normalized;
    }

    private normalizeOwnedThemes(items: any[]): ThemeMeta[] {
        if (!Array.isArray(items) || !items.length) return [];
        const byId: { [key: string]: ThemeMeta } = {};
        for (const theme of this.themes) {
            byId[theme.id] = theme;
        }
        const ids: string[] = [];
        for (const item of items) {
            const id = String(item?.cssThemeId || item?.id || '').trim() as MinihompyThemeId;
            if (!this.isTheme(id) || ids.indexOf(id) >= 0) continue;
            const catalog = byId[id];
            ids.push(id);
            byId[id] = {
                id,
                label: String(item?.label || catalog.label),
                tone: String(item?.tone || item?.description || catalog.tone)
            };
        }
        return this.themes
            .filter((theme: ThemeMeta) => ids.indexOf(theme.id) >= 0)
            .map((theme: ThemeMeta) => byId[theme.id]);
    }

    private normalizeOwnedMiniroomBackgrounds(items: any[], backgrounds: MiniroomBackground[]): MiniroomBackground[] {
        if (!Array.isArray(items) || !items.length) return [];
        const byId: { [key: string]: MiniroomBackground } = {};
        for (const background of backgrounds) {
            byId[background.id] = background;
        }
        const ids: string[] = [];
        const result: MiniroomBackground[] = [];
        for (const item of items) {
            const id = String(item?.id || '').trim();
            if (!id || ids.indexOf(id) >= 0) continue;
            const background = byId[id] || this.toMiniroomBackground(item);
            if (!background) continue;
            ids.push(id);
            result.push(background);
        }
        return result;
    }

    private toMiniroomBackground(item: any): MiniroomBackground | null {
        const id = String(item?.id || '').trim();
        const assetPath = String(item?.assetPath || item?.asset_path || '').trim();
        if (!id || !assetPath) return null;
        const mimeType = String(item?.mimeType || item?.mime_type || this.miniroomMimeType(assetPath));
        return {
            id,
            ownerId: String(item?.ownerId || item?.owner_id || this.minihompy.ownerId || ''),
            minihompyId: String(item?.minihompyId || item?.minihompy_id || this.minihompy.id || ''),
            fileId: String(item?.fileId || item?.file_id || ''),
            assetPath,
            title: String(item?.title || item?.displayName || item?.display_name || id),
            description: String(item?.description || ''),
            originalFilename: String(item?.originalFilename || item?.original_filename || this.fileNameFromUrl(assetPath)),
            storedFilename: String(item?.storedFilename || item?.stored_filename || ''),
            mimeType,
            fileSize: Number(item?.fileSize || item?.file_size || 0),
            isAnimated: Boolean(item?.isAnimated || item?.is_animated || mimeType === 'image/gif'),
            width: Number(item?.width || 0),
            height: Number(item?.height || 0),
            sourceType: String(item?.sourceType || item?.source_type || ''),
            status: String(item?.status || 'ACTIVE'),
            createdAt: String(item?.createdAt || item?.created_at || ''),
            updatedAt: String(item?.updatedAt || item?.updated_at || '')
        };
    }

    private buildSettingsPayload(): SettingsForm {
        return {
            nickname: this.settingsForm.nickname,
            title: this.settingsForm.title,
            statusMessage: this.settingsForm.statusMessage,
            profileImageUrl: this.settingsForm.profileImageUrl,
            bio: this.settingsForm.bio,
            themeId: this.activeTheme,
            defaultDiaryVisibility: this.settingsForm.defaultDiaryVisibility,
            defaultPhotoVisibility: this.settingsForm.defaultPhotoVisibility,
            selectedMiniroomBackgroundId: this.settingsForm.selectedMiniroomBackgroundId,
            miniroomBackgroundFit: this.normalizeMiniroomBackgroundFit(this.settingsForm.miniroomBackgroundFit),
            guestbookWritePolicy: this.settingsForm.guestbookWritePolicy,
            bgmEnabled: Boolean(this.settingsForm.bgmEnabled),
            bgmTrackTitle: this.settingsForm.bgmTrackTitle
        };
    }

    private buildMiniroomBackgroundPayload(): any {
        const assetPath = String(this.miniroomBackgroundForm.assetPath || '').trim();
        return {
            title: String(this.miniroomBackgroundForm.title || '').trim(),
            assetPath,
            description: String(this.miniroomBackgroundForm.description || '').trim(),
            originalFilename: String(this.miniroomBackgroundForm.originalFilename || this.fileNameFromUrl(assetPath)).trim(),
            mimeType: this.miniroomBackgroundForm.mimeType || this.miniroomMimeType(assetPath),
            width: Number(this.miniroomBackgroundForm.width || 0),
            height: Number(this.miniroomBackgroundForm.height || 0)
        };
    }

    private createDefaultMinihompy(): MinihompyProfile {
        return {
            id: 'mh_mock_owner',
            ownerId: 'jiwon',
            slug: this.defaultSlug,
            visibility: 'PUBLIC',
            status: 'ACTIVE',
            nickname: '김지원',
            title: 'Recollections',
            statusMessage: '작은 기억을 천천히 정리하는 중입니다.',
            profileImageUrl: '',
            bio: '느린 기록, 사진, 방명록을 천천히 모아두는 작은 웹 방입니다.',
            themeId: 'sky',
            defaultDiaryVisibility: 'PUBLIC',
            defaultPhotoVisibility: 'ILCHON',
            selectedMiniroomBackgroundId: 'miniroom_bg_01',
            selectedMiniroomBackgroundAssetPath: '/assets/miniroom-backgrounds/1CD95E86-14C8-46B3-9B20-235F4281977C.gif',
            selectedMiniroomBackground: null,
            miniroomBackgroundFit: 'contain',
            guestbookWritePolicy: 'AUTHENTICATED',
            bgmEnabled: true,
            bgmTrackTitle: 'Memory Loop 01',
            todayVisitCount: 128,
            totalVisitCount: 48219,
            updatedAt: '2026-05-26 00:00:00'
        };
    }

    private createFallbackMiniroomBackgrounds(ownerId?: string): MiniroomBackground[] {
        return MINIROOM_BACKGROUND_FILES.map((fileName: string, index: number) => {
            const sequence = String(index + 1).padStart(2, '0');
            const mimeType = this.miniroomMimeType(fileName);
            return {
                id: `miniroom_bg_${sequence}`,
                ownerId: ownerId || this.minihompy?.ownerId || 'jiwon',
                minihompyId: this.minihompy?.id || 'mh_mock_owner',
                fileId: '',
                assetPath: `/assets/miniroom-backgrounds/${fileName}`,
                title: `Miniroom Background ${sequence}`,
                description: '',
                originalFilename: fileName,
                storedFilename: '',
                mimeType,
                fileSize: 0,
                isAnimated: mimeType === 'image/gif',
                width: 0,
                height: 0,
                sourceType: 'STATIC_ASSET',
                status: 'ACTIVE',
                createdAt: '',
                updatedAt: ''
            };
        });
    }

    private resolveMiniroomBackgrounds(items: MiniroomBackground[], ownerId?: string): MiniroomBackground[] {
        if (Array.isArray(items) && items.length) {
            return items;
        }
        return this.createFallbackMiniroomBackgrounds(ownerId);
    }

    private resolveMiniroomBackgroundId(backgroundId: string, backgrounds: MiniroomBackground[], allowEmpty: boolean = false, useStoredFallback: boolean = true): string {
        const hasBackground = (id: string): boolean => backgrounds.some((background: MiniroomBackground) => background.id === id);
        const requestedId = String(backgroundId || '');

        if (allowEmpty) {
            return requestedId && hasBackground(requestedId) ? requestedId : '';
        }

        if (requestedId && hasBackground(requestedId)) return requestedId;

        const storedId = useStoredFallback ? window.localStorage.getItem(this.miniroomBackgroundStorageKey()) : null;
        if (storedId !== null && useStoredFallback) {
            return storedId && hasBackground(storedId) ? storedId : '';
        }

        return backgrounds.length ? backgrounds[0].id : '';
    }

    private resolveMiniroomBackgroundFit(value: string): MiniroomBackgroundFit {
        const storedFit = window.localStorage.getItem(this.miniroomBackgroundFitStorageKey());
        if (storedFit) {
            return this.normalizeMiniroomBackgroundFit(storedFit);
        }
        return this.normalizeMiniroomBackgroundFit(value);
    }

    private miniroomBackgroundStorageKey(): string {
        return `${MINIROOM_BACKGROUND_STORAGE_KEY}:${this.slug || this.defaultSlug}`;
    }

    private miniroomBackgroundFitStorageKey(): string {
        return `${MINIROOM_BACKGROUND_FIT_STORAGE_KEY}:${this.slug || this.defaultSlug}`;
    }

    private miniroomMimeType(fileName: string): string {
        const lowerName = String(fileName || '').toLowerCase();
        if (lowerName.endsWith('.gif')) return 'image/gif';
        if (lowerName.endsWith('.png')) return 'image/png';
        if (lowerName.endsWith('.jpg') || lowerName.endsWith('.jpeg')) return 'image/jpeg';
        return 'application/octet-stream';
    }

    private createDefaultRelationship(): RelationshipContext {
        return {
            status: 'NONE',
            targetUserId: this.minihompy.ownerId || 'jiwon',
            targetName: this.minihompy.nickname || '미니홈피 주인',
            viewerUserId: '',
            viewerName: '방문자',
            canRequest: false,
            canAccept: false,
            canDelete: false,
            canBlock: false
        };
    }

    private createDefaultIlchonOverview(): IlchonOverview {
        return {
            accepted: [],
            incoming: [],
            outgoing: [],
            blocked: []
        };
    }

    private createDefaultModeration(): ModerationPayload {
        return {
            canModerate: false,
            statusOptions: ['PENDING_REVIEW', 'HIDDEN_BY_MODERATOR', 'DELETED'],
            reports: []
        };
    }

    private createSettingsForm(minihompy: MinihompyProfile): SettingsForm {
        return {
            nickname: minihompy.nickname,
            title: minihompy.title,
            statusMessage: minihompy.statusMessage,
            profileImageUrl: minihompy.profileImageUrl || '',
            bio: minihompy.bio,
            themeId: minihompy.themeId,
            defaultDiaryVisibility: minihompy.defaultDiaryVisibility,
            defaultPhotoVisibility: minihompy.defaultPhotoVisibility,
            selectedMiniroomBackgroundId: minihompy.selectedMiniroomBackgroundId || '',
            miniroomBackgroundFit: this.normalizeMiniroomBackgroundFit(minihompy.miniroomBackgroundFit),
            guestbookWritePolicy: minihompy.guestbookWritePolicy,
            bgmEnabled: Boolean(minihompy.bgmEnabled),
            bgmTrackTitle: minihompy.bgmTrackTitle || 'Memory Loop 01'
        };
    }

    private createEmptyDiaryForm(): DiaryForm {
        return {
            id: '',
            title: '',
            body: '',
            entryDate: this.today(),
            mood: 'note',
            visibility: this.minihompy.defaultDiaryVisibility || 'PUBLIC'
        };
    }

    private createEmptyGuestbookForm(): GuestbookForm {
        return {
            message: ''
        };
    }

    private createEmptyPhotoAlbumForm(): PhotoAlbumForm {
        return {
            id: '',
            name: '',
            note: '',
            visibility: this.minihompy.defaultPhotoVisibility || 'ILCHON'
        };
    }

    private createEmptyPhotoForm(): PhotoForm {
        const album = this.selectedPhotoAlbum;
        return {
            id: '',
            albumId: album ? album.id : '',
            title: '',
            caption: '',
            takenAt: this.today(),
            sourceUrl: '',
            fileName: '',
            mimeType: 'image/jpeg',
            fileSize: 0,
            visibility: 'INHERIT'
        };
    }

    private createEmptyMiniroomBackgroundForm(): MiniroomBackgroundForm {
        return {
            id: '',
            title: '',
            assetPath: '',
            description: '',
            originalFilename: '',
            mimeType: 'image/gif',
            width: 0,
            height: 0
        };
    }

    private findMiniroomBackgroundByTitle(title: string): MiniroomBackground | null {
        const normalized = String(title || '').trim();
        if (!normalized) return null;
        const matches = this.miniroomBackgrounds.filter((background: MiniroomBackground) => background.title === normalized);
        return matches[matches.length - 1] || null;
    }

    private fileNameFromUrl(value: string): string {
        const clean = String(value || '').split('?')[0].replace(/\/+$/, '');
        if (!clean) return '';
        return clean.split('/').pop() || '';
    }

    private titleFromFileName(value: string): string {
        const fileName = this.fileNameFromUrl(value);
        const title = fileName.replace(/\.[^.]+$/, '').replace(/[_-]+/g, ' ').trim();
        return title || '미니룸 배경';
    }

    private formatFileSize(value: number): string {
        const bytes = Number(value || 0);
        if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
        if (bytes >= 1024) return `${Math.round(bytes / 1024)}KB`;
        return `${bytes}B`;
    }

    private today(): string {
        const date = new Date();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${date.getFullYear()}-${month}-${day}`;
    }

    private currentMonth(): string {
        return this.today().slice(0, 7);
    }

    private entryMonth(entry: DiaryEntry): string {
        return entry.month || (entry.entryDate || '').slice(0, 7);
    }

    private syncDiarySelection(): void {
        const months = this.diaryMonths.map((month: DiaryMonth) => month.key);
        if (!months.length) {
            this.selectedDiaryMonth = this.currentMonth();
            this.selectedDiary = null;
            return;
        }
        if (!this.selectedDiaryMonth || months.indexOf(this.selectedDiaryMonth) < 0) {
            this.selectedDiaryMonth = months[0];
        }
        if (this.selectedDiary && !this.diaryEntries.some((entry: DiaryEntry) => entry.id === this.selectedDiary?.id)) {
            this.selectedDiary = null;
        }
        if (!this.selectedDiary) {
            this.selectedDiary = this.filteredDiaryEntries[0] || null;
        }
    }

    private syncPhotoSelection(): void {
        if (!this.photoAlbums.length) {
            this.selectedPhotoAlbumId = '';
            this.selectedPhoto = null;
            return;
        }
        if (!this.selectedPhotoAlbumId || !this.photoAlbums.some((album: PhotoAlbum) => album.id === this.selectedPhotoAlbumId)) {
            this.selectedPhotoAlbumId = this.photoAlbums[0].id;
        }
        if (this.selectedPhoto && !this.photos.some((photo: PhotoItem) => photo.id === this.selectedPhoto?.id)) {
            this.selectedPhoto = null;
        }
        if (!this.selectedPhoto || this.selectedPhoto.albumId !== this.selectedPhotoAlbumId) {
            this.selectedPhoto = this.selectedAlbumPhotos[0] || null;
        }
    }

    private syncRouteState(): boolean {
        const before = `${this.slug}:${this.activeTab}`;
        const firstSegment = this.cleanSegment(WizRoute.segment.slug || '');
        const secondSegment = this.cleanSegment(WizRoute.segment.tab || '');
        const firstAsTab = this.resolveTab(firstSegment);

        if (firstAsTab) {
            this.slug = this.defaultSlug;
            this.activeTab = firstAsTab;
        } else {
            this.slug = firstSegment || this.defaultSlug;
            this.activeTab = this.resolveTab(secondSegment) || 'Home';
        }

        return before !== `${this.slug}:${this.activeTab}`;
    }

    private cleanSegment(value: string): string {
        if (!value) return '';
        let normalized = value;
        try {
            normalized = decodeURIComponent(value);
        } catch (error) {
            normalized = value;
        }
        return normalized.trim().toLowerCase();
    }

    private ensureCanonicalTabUrl(): void {
        const target = this.tabPath(this.activeTab);
        const currentPath = window.location.pathname.replace(/\/$/, '');
        if (currentPath !== target || window.location.hash) {
            this.service.href(target);
        }
    }

    private tabPath(tab: MinihompyTab): string {
        const meta = this.tabs.find((item: TabMeta) => item.id === tab) || this.tabs[0];
        return `/dashboard/${this.slug || this.defaultSlug}/${meta.slug}`;
    }

    private resolveTab(value: string): MinihompyTab | null {
        if (!value) return null;

        const normalized = value.toLowerCase();
        const match = this.tabs.find((tab: TabMeta) => {
            return tab.slug === normalized || tab.id.toLowerCase() === normalized || tab.label.toLowerCase() === normalized;
        });
        return match ? match.id : null;
    }

    private isTheme(value: string): value is MinihompyThemeId {
        return this.themes.some((theme: ThemeMeta) => theme.id === value);
    }

    private normalizeMiniroomBackgroundFit(value: string): MiniroomBackgroundFit {
        return 'contain';
    }
}

export default PageDashboardComponent;